(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define('ProfileProctorGroups', [], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.ProfileProctorGroups = factory();
  }
}(this, function() {

  /**
   * Sets proctor groups based on an array of integer values
   * that matches the number of tests in the proctor specification
   * and is in alphabetical order with respect to proctor test names.
   *
   * If no values are supplied, sets default values for all groups.
   *
   * @param {Array.<Object>=} opt_values a list of integers that matches proctor test groups for the request.
   * @private
   * @constructor
   */
    var ProfileProctorGroups_ = function(opt_values) {
        if (opt_values) {
            if (Array.isArray(opt_values)) {
                var testDef;
                testDef = opt_values[0];
                this.hiredsignal_resume_autocomplete_tstValue_ = testDef[0];
                testDef = opt_values[1];
                this.ia_override_native_app_cancel_button_tstValue_ = testDef[0];
                testDef = opt_values[2];
                this.in_resume_builder_certificationValue_ = testDef[0];
                testDef = opt_values[3];
                this.in_resume_builder_language_proficiency_pageValue_ = testDef[0];
                testDef = opt_values[4];
                this.in_resume_upload_profile_missing_info_tstValue_ = testDef[0];
                testDef = opt_values[5];
                this.intl_non_pdf_searchability_lockValue_ = testDef[0];
                testDef = opt_values[6];
                this.iosnative_premium_profile_insightsValue_ = testDef[0];
                testDef = opt_values[7];
                this.iosnative_rich_profilesValue_ = testDef[0];
                testDef = opt_values[8];
                this.jp_match_myoffers_guide_copy_changeValue_ = testDef[0];
                testDef = opt_values[9];
                this.jp_public_resume_optin_copy_tstValue_ = testDef[0];
                testDef = opt_values[10];
                this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstValue_ = testDef[0];
                this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstPayloadValue_ = testDef[1];
                testDef = opt_values[11];
                this.jpm_updated_communication_policy_togValue_ = testDef[0];
                testDef = opt_values[12];
                this.jpmp_jsg_pow_rag_promo_tstValue_ = testDef[0];
                this.jpmp_jsg_pow_rag_promo_tstPayloadValue_ = testDef[1];
                testDef = opt_values[13];
                this.jpmp_jsg_pow_rng_promo_tstValue_ = testDef[0];
                testDef = opt_values[14];
                this.jpmp_jsg_use_jobseeker_raw_location_togValue_ = testDef[0];
                testDef = opt_values[15];
                this.js_pro_actionable_checklist_tstValue_ = testDef[0];
                testDef = opt_values[16];
                this.js_pro_auto_apply_pow_tstValue_ = testDef[0];
                testDef = opt_values[17];
                this.js_pro_profile_enhancements_tstValue_ = testDef[0];
                testDef = opt_values[18];
                this.jsj_crowtaxo_holdout_tstValue_ = testDef[0];
                testDef = opt_values[19];
                this.jso_minimal_onboarding_tstValue_ = testDef[0];
                testDef = opt_values[20];
                this.jso_onboarding_jsf_tstValue_ = testDef[0];
                testDef = opt_values[21];
                this.jsu_employer_blocking_tstValue_ = testDef[0];
                testDef = opt_values[22];
                this.jsu_profile_location_component_tstValue_ = testDef[0];
                this.jsu_profile_location_component_tstPayloadValue_ = testDef[1];
                testDef = opt_values[23];
                this.mosaic_js_premium_parent_tstValue_ = testDef[0];
                testDef = opt_values[24];
                this.myindallowfileonlytoggleValue_ = testDef[0];
                testDef = opt_values[25];
                this.myindresumebuildertstValue_ = testDef[0];
                testDef = opt_values[26];
                this.pcs_qualifications_disclaimerValue_ = testDef[0];
                testDef = opt_values[27];
                this.pet_cpra_donotsellsharelink_tstValue_ = testDef[0];
                testDef = opt_values[28];
                this.pow_create_merged_profiles_tstValue_ = testDef[0];
                testDef = opt_values[29];
                this.pow_crowtaxo_disclosure_tstValue_ = testDef[0];
                testDef = opt_values[30];
                this.pow_current_salary_page_mvr_builderValue_ = testDef[0];
                testDef = opt_values[31];
                this.pow_edu_training_representation_splitValue_ = testDef[0];
                testDef = opt_values[32];
                this.pow_employment_eligibility_tstValue_ = testDef[0];
                testDef = opt_values[33];
                this.pow_europe_builder_flow_tstValue_ = testDef[0];
                testDef = opt_values[34];
                this.pow_first_last_name_validationValue_ = testDef[0];
                testDef = opt_values[35];
                this.pow_hiredsignal_sourceability_toggle_tstValue_ = testDef[0];
                testDef = opt_values[36];
                this.pow_intl_fields_resume_localeValue_ = testDef[0];
                testDef = opt_values[37];
                this.pow_languages_field_migrationValue_ = testDef[0];
                testDef = opt_values[38];
                this.pow_multiple_resume_tstValue_ = testDef[0];
                testDef = opt_values[39];
                this.pow_override_native_app_cancel_button_tstValue_ = testDef[0];
                testDef = opt_values[40];
                this.pow_phone_page_mvr_builderValue_ = testDef[0];
                testDef = opt_values[41];
                this.pow_privacy_promo_tstValue_ = testDef[0];
                testDef = opt_values[42];
                this.pow_re_resume_localeValue_ = testDef[0];
                testDef = opt_values[43];
                this.pow_redesign_locale_pickerValue_ = testDef[0];
                testDef = opt_values[44];
                this.pow_reusable_pay_component_tstValue_ = testDef[0];
                testDef = opt_values[45];
                this.pow_skills_test_deprecationValue_ = testDef[0];
                testDef = opt_values[46];
                this.pow_skills_validationValue_ = testDef[0];
                testDef = opt_values[47];
                this.prof_auto_resume_sections_schema_tstValue_ = testDef[0];
                testDef = opt_values[48];
                this.prof_completion_widgetValue_ = testDef[0];
                testDef = opt_values[49];
                this.prof_data_merge_parsed_resume_tstValue_ = testDef[0];
                testDef = opt_values[50];
                this.prof_employer_blocking_sourcing_opt_inValue_ = testDef[0];
                testDef = opt_values[51];
                this.prof_fe_merge_second_phaseValue_ = testDef[0];
                testDef = opt_values[52];
                this.prof_jp_no_thumbnailValue_ = testDef[0];
                testDef = opt_values[53];
                this.prof_mvp_data_merge_crowtaxo_togValue_ = testDef[0];
                this.prof_mvp_data_merge_crowtaxo_togPayloadValue_ = testDef[1];
                testDef = opt_values[54];
                this.prof_pdf_confirmationValue_ = testDef[0];
                testDef = opt_values[55];
                this.prof_preference_improvement_toggleValue_ = testDef[0];
                testDef = opt_values[56];
                this.prof_rdi_auto_merge_alert_togValue_ = testDef[0];
                testDef = opt_values[57];
                this.prof_rdi_single_page_togValue_ = testDef[0];
                testDef = opt_values[58];
                this.prof_remove_convert_to_indeed_resume_optionValue_ = testDef[0];
                testDef = opt_values[59];
                this.prof_rn_two_tabValue_ = testDef[0];
                testDef = opt_values[60];
                this.prof_sg_work_auth_for_parsed_rez_tstValue_ = testDef[0];
                testDef = opt_values[61];
                this.prof_tabbed_expValue_ = testDef[0];
                testDef = opt_values[62];
                this.prof_tabbed_exp_resume_data_importValue_ = testDef[0];
                testDef = opt_values[63];
                this.prof_tabbed_exp_smiley_surveyValue_ = testDef[0];
                testDef = opt_values[64];
                this.prof_upload_file_redaction_tstValue_ = testDef[0];
                testDef = opt_values[65];
                this.profauto_doc_to_pdf_conversion_tstValue_ = testDef[0];
                testDef = opt_values[66];
                this.profauto_pow_commute_time_tstValue_ = testDef[0];
                testDef = opt_values[67];
                this.profile_ai_summary_tstValue_ = testDef[0];
                testDef = opt_values[68];
                this.profile_ai_work_description_tstValue_ = testDef[0];
                testDef = opt_values[69];
                this.profile_extracted_qualifications_tstValue_ = testDef[0];
                testDef = opt_values[70];
                this.profile_one_csp_mode_togValue_ = testDef[0];
                testDef = opt_values[71];
                this.profile_one_datadog_rum_toggleValue_ = testDef[0];
                testDef = opt_values[72];
                this.profile_one_fullstory_tstValue_ = testDef[0];
                testDef = opt_values[73];
                this.profile_one_redesign_preferences_tstValue_ = testDef[0];
                testDef = opt_values[74];
                this.profile_phone_simplificationValue_ = testDef[0];
                testDef = opt_values[75];
                this.profile_photos_togValue_ = testDef[0];
                testDef = opt_values[76];
                this.profile_score_tstValue_ = testDef[0];
                testDef = opt_values[77];
                this.profile_text_experience_input_tstValue_ = testDef[0];
                testDef = opt_values[78];
                this.profile_title_match_autocomplete_dataset_tstValue_ = testDef[0];
                this.profile_title_match_autocomplete_dataset_tstPayloadValue_ = testDef[1];
                testDef = opt_values[79];
                this.profile_update_app_banner_togValue_ = testDef[0];
                testDef = opt_values[80];
                this.profile_yoe_removal_togValue_ = testDef[0];
                testDef = opt_values[81];
                this.rdp_modernizationValue_ = testDef[0];
                testDef = opt_values[82];
                this.rdp_modernization_powValue_ = testDef[0];
                testDef = opt_values[83];
                this.rdp_pdf_resume_faceliftValue_ = testDef[0];
                testDef = opt_values[84];
                this.re_upload_to_replaceValue_ = testDef[0];
                testDef = opt_values[85];
                this.si_profile_education_description_initially_hidden_tstValue_ = testDef[0];
            } else {
                var testDef;
                testDef = opt_values["c93e7e9a928e7d2b694e14c767294d610a6fcd60c05b68011f2b087ae9f4a14c"];
                if (!testDef) {
                    this.jsj_crowtaxo_holdout_tstValue_ = -1;
                } else {
                    this.jsj_crowtaxo_holdout_tstValue_ = testDef[0];
                }
                testDef = opt_values["bdf467b4a6de4b2e232704392efaf69d9a8c0b312b098f193ed3067488503f72"];
                if (!testDef) {
                    this.rdp_pdf_resume_faceliftValue_ = -1;
                } else {
                    this.rdp_pdf_resume_faceliftValue_ = testDef[0];
                }
                testDef = opt_values["78b8f07b14720acd9e5bc90bf11f9da94860090a57c8bc65571f90f1d958e12b"];
                if (!testDef) {
                    this.jpmp_jsg_pow_rag_promo_tstValue_ = -1;
                    this.jpmp_jsg_pow_rag_promo_tstPayloadValue_ = {};
                } else {
                    this.jpmp_jsg_pow_rag_promo_tstValue_ = testDef[0];
                    this.jpmp_jsg_pow_rag_promo_tstPayloadValue_ = testDef[1];
                }
                testDef = opt_values["5b696af89ccdf05ee43a6fd923dec2535f91b063a60b580e6f8b599767cc1cca"];
                if (!testDef) {
                    this.pow_current_salary_page_mvr_builderValue_ = -1;
                } else {
                    this.pow_current_salary_page_mvr_builderValue_ = testDef[0];
                }
                testDef = opt_values["b812a6e632bf2127e95a6b87043cdecb79877e267c70f812edf0bd6022fd3f33"];
                if (!testDef) {
                    this.pow_first_last_name_validationValue_ = -1;
                } else {
                    this.pow_first_last_name_validationValue_ = testDef[0];
                }
                testDef = opt_values["398dad6ac7a10b741e963de9d04ea60a166c555e6a11d63754534f3b846a03b0"];
                if (!testDef) {
                    this.prof_mvp_data_merge_crowtaxo_togValue_ = -1;
                    this.prof_mvp_data_merge_crowtaxo_togPayloadValue_ = {};
                } else {
                    this.prof_mvp_data_merge_crowtaxo_togValue_ = testDef[0];
                    this.prof_mvp_data_merge_crowtaxo_togPayloadValue_ = testDef[1];
                }
                testDef = opt_values["80cc05edf4cb2607f3ea9aa2039780d5fa99d6a25748dd0b18e0ee8c60982331"];
                if (!testDef) {
                    this.in_resume_builder_certificationValue_ = -1;
                } else {
                    this.in_resume_builder_certificationValue_ = testDef[0];
                }
                testDef = opt_values["a22199d4c2fd5fb6e9dc285f1cab94591371fccd1acaba2f6e9cb28204a0ef52"];
                if (!testDef) {
                    this.pow_employment_eligibility_tstValue_ = -1;
                } else {
                    this.pow_employment_eligibility_tstValue_ = testDef[0];
                }
                testDef = opt_values["61090043438f9a82e2cee6b3fb4a964b0e4a20a4858f5aa31b40872d18cf38b2"];
                if (!testDef) {
                    this.mosaic_js_premium_parent_tstValue_ = -1;
                } else {
                    this.mosaic_js_premium_parent_tstValue_ = testDef[0];
                }
                testDef = opt_values["5ca2ab176d7fe6ca7417c52ee48730c19bd3aaf7bd68204150ef06c931044308"];
                if (!testDef) {
                    this.pow_privacy_promo_tstValue_ = -1;
                } else {
                    this.pow_privacy_promo_tstValue_ = testDef[0];
                }
                testDef = opt_values["c84d4f5fa9ca05b56c0ece20b5cec21ffbd241ca9893781e757085e3a9a6caa5"];
                if (!testDef) {
                    this.profile_one_fullstory_tstValue_ = -1;
                } else {
                    this.profile_one_fullstory_tstValue_ = testDef[0];
                }
                testDef = opt_values["53be4f6d7c5870bf79799a5824fcbb5f464d6986ad558cb8e27872ade8e02583"];
                if (!testDef) {
                    this.profile_yoe_removal_togValue_ = -1;
                } else {
                    this.profile_yoe_removal_togValue_ = testDef[0];
                }
                testDef = opt_values["9347a308297cccb7a88a148d1c298525cc0f856605598a960bb7a3be5082f7dc"];
                if (!testDef) {
                    this.jso_minimal_onboarding_tstValue_ = -1;
                } else {
                    this.jso_minimal_onboarding_tstValue_ = testDef[0];
                }
                testDef = opt_values["6cf0728ab99874b2707350694eb17c5648288f467ee2509114cb4ba2e0cdda12"];
                if (!testDef) {
                    this.pow_skills_test_deprecationValue_ = -1;
                } else {
                    this.pow_skills_test_deprecationValue_ = testDef[0];
                }
                testDef = opt_values["5c5d7bdfcc5fde07d7eaaee0e02e09906861ab54f409ba6798ea5c1e0ad2ab85"];
                if (!testDef) {
                    this.prof_rdi_auto_merge_alert_togValue_ = -1;
                } else {
                    this.prof_rdi_auto_merge_alert_togValue_ = testDef[0];
                }
                testDef = opt_values["657bd2b136435560599aa59ac72f30d56d727be134bcaf8d30e9179b49572ea0"];
                if (!testDef) {
                    this.js_pro_auto_apply_pow_tstValue_ = -1;
                } else {
                    this.js_pro_auto_apply_pow_tstValue_ = testDef[0];
                }
                testDef = opt_values["50757c044f5c66d3386ac5b45b996b58f5e3b03c98688bfd4faaeb3d6106a990"];
                if (!testDef) {
                    this.prof_completion_widgetValue_ = -1;
                } else {
                    this.prof_completion_widgetValue_ = testDef[0];
                }
                testDef = opt_values["ef2cf9ae830f32d8dfe0ba13aa7fdc1539b0c3b2668bfa7b86a35eae7cebd272"];
                if (!testDef) {
                    this.myindresumebuildertstValue_ = -1;
                } else {
                    this.myindresumebuildertstValue_ = testDef[0];
                }
                testDef = opt_values["575dff7492334d7f304feae55b42524b6b1d903eae38b866487d03f172576ef7"];
                if (!testDef) {
                    this.profile_score_tstValue_ = -1;
                } else {
                    this.profile_score_tstValue_ = testDef[0];
                }
                testDef = opt_values["226d6062d50de1ae523dae0e151831c91715899e96990282c87c4f05577bd824"];
                if (!testDef) {
                    this.pow_reusable_pay_component_tstValue_ = -1;
                } else {
                    this.pow_reusable_pay_component_tstValue_ = testDef[0];
                }
                testDef = opt_values["e257beb354906923eb561e6235b26777dcb3db513186721d51c0864a38965b1a"];
                if (!testDef) {
                    this.prof_pdf_confirmationValue_ = -1;
                } else {
                    this.prof_pdf_confirmationValue_ = testDef[0];
                }
                testDef = opt_values["4800448cd65e0fe212413ac99f6e09cdc713ab0655138c534496d7b6e2adc393"];
                if (!testDef) {
                    this.pow_europe_builder_flow_tstValue_ = -1;
                } else {
                    this.pow_europe_builder_flow_tstValue_ = testDef[0];
                }
                testDef = opt_values["e916dcb4c22df23b0a7bc5d40f10f52cb9ddbab2b70914531411cff3834ce300"];
                if (!testDef) {
                    this.pow_override_native_app_cancel_button_tstValue_ = -1;
                } else {
                    this.pow_override_native_app_cancel_button_tstValue_ = testDef[0];
                }
                testDef = opt_values["59bc93d4615d5d2b8c8d3ce6aeb0aac7a5515448800b3f4dc9875d2796b485fb"];
                if (!testDef) {
                    this.hiredsignal_resume_autocomplete_tstValue_ = -1;
                } else {
                    this.hiredsignal_resume_autocomplete_tstValue_ = testDef[0];
                }
                testDef = opt_values["ee6596b530d277b03e27e7559260cc1343816da944130d4c770d5e5929dddd1a"];
                if (!testDef) {
                    this.iosnative_premium_profile_insightsValue_ = -1;
                } else {
                    this.iosnative_premium_profile_insightsValue_ = testDef[0];
                }
                testDef = opt_values["c625504c8ddce42e43e3bc7a0561700181a5b6c8d6f2f0dd467d9ebc6d3b32f7"];
                if (!testDef) {
                    this.profile_ai_summary_tstValue_ = -1;
                } else {
                    this.profile_ai_summary_tstValue_ = testDef[0];
                }
                testDef = opt_values["589c5cc0a18fd46d97acf537721c9f8f6efe15d5eb32346d26cea5e5a3bfaf9a"];
                if (!testDef) {
                    this.profile_ai_work_description_tstValue_ = -1;
                } else {
                    this.profile_ai_work_description_tstValue_ = testDef[0];
                }
                testDef = opt_values["6a16f84bbe6c96cfec47658cc44f7054d74d0899fe3d08fa835e37b95e5709f2"];
                if (!testDef) {
                    this.jsu_employer_blocking_tstValue_ = -1;
                } else {
                    this.jsu_employer_blocking_tstValue_ = testDef[0];
                }
                testDef = opt_values["6cdba8b648fe3b0be287ea8446a75a416654070d04cdcd444479bc409b7b999f"];
                if (!testDef) {
                    this.pow_re_resume_localeValue_ = -1;
                } else {
                    this.pow_re_resume_localeValue_ = testDef[0];
                }
                testDef = opt_values["ffe375f72d50c43f335b6edc31efd40f618ff214c967cf914f33810cc5892cee"];
                if (!testDef) {
                    this.pow_phone_page_mvr_builderValue_ = -1;
                } else {
                    this.pow_phone_page_mvr_builderValue_ = testDef[0];
                }
                testDef = opt_values["dab2c62151f3a60c3eaee06e2b49244271266bdca288b77aa8645a2a5777e3bc"];
                if (!testDef) {
                    this.js_pro_actionable_checklist_tstValue_ = -1;
                } else {
                    this.js_pro_actionable_checklist_tstValue_ = testDef[0];
                }
                testDef = opt_values["9321f4d47c321c5ef8a05470a3d55f42f8f395d2a5edc92fdfc7ab3cfd84b1e4"];
                if (!testDef) {
                    this.prof_tabbed_exp_resume_data_importValue_ = -1;
                } else {
                    this.prof_tabbed_exp_resume_data_importValue_ = testDef[0];
                }
                testDef = opt_values["bacff8adcd6b666f4c54bae0f78fe4feda48785c605d8fd76898be130c387d41"];
                if (!testDef) {
                    this.ia_override_native_app_cancel_button_tstValue_ = -1;
                } else {
                    this.ia_override_native_app_cancel_button_tstValue_ = testDef[0];
                }
                testDef = opt_values["eb549a2ff4d1eab7ed0beed3a17aac06c8bf22ede238d07073fb9d104b342687"];
                if (!testDef) {
                    this.profile_one_redesign_preferences_tstValue_ = -1;
                } else {
                    this.profile_one_redesign_preferences_tstValue_ = testDef[0];
                }
                testDef = opt_values["9cdd4efad26780ac4b79ab68750a68452ee6041a363754e95d4ed813d6716da4"];
                if (!testDef) {
                    this.js_pro_profile_enhancements_tstValue_ = -1;
                } else {
                    this.js_pro_profile_enhancements_tstValue_ = testDef[0];
                }
                testDef = opt_values["c34f8a730dbf1f623a46d52040afb6251b2e6cacaf4be6b410419cc5c5347c80"];
                if (!testDef) {
                    this.profauto_pow_commute_time_tstValue_ = -1;
                } else {
                    this.profauto_pow_commute_time_tstValue_ = testDef[0];
                }
                testDef = opt_values["50a3085b73cf9e584034ac24f563c489db15e9d227e69d22db27bf075db55261"];
                if (!testDef) {
                    this.profile_text_experience_input_tstValue_ = -1;
                } else {
                    this.profile_text_experience_input_tstValue_ = testDef[0];
                }
                testDef = opt_values["5d7cdb517d8c7ef58493c6cce9ce39fa63f7f3d91e99730832a49a3d1b284ef7"];
                if (!testDef) {
                    this.prof_rn_two_tabValue_ = -1;
                } else {
                    this.prof_rn_two_tabValue_ = testDef[0];
                }
                testDef = opt_values["8791a66d0cbf2e7c752424f2e19b81ebecadc512645a4372156721c6551ac902"];
                if (!testDef) {
                    this.profile_one_csp_mode_togValue_ = -1;
                } else {
                    this.profile_one_csp_mode_togValue_ = testDef[0];
                }
                testDef = opt_values["ddbc7173f0bc4a31e771dbc4a567ad35316c7ee1b845636efd4f6b035ab4daf8"];
                if (!testDef) {
                    this.pow_create_merged_profiles_tstValue_ = -1;
                } else {
                    this.pow_create_merged_profiles_tstValue_ = testDef[0];
                }
                testDef = opt_values["deb4c877f41850ad3fe5a1f2e14b1a4c460505015a680aaa2ed2f23fd4e12d67"];
                if (!testDef) {
                    this.jso_onboarding_jsf_tstValue_ = -1;
                } else {
                    this.jso_onboarding_jsf_tstValue_ = testDef[0];
                }
                testDef = opt_values["2d1c84242b61780cb5c6e1288e3e7306162831a7b387cf9dc27e489af4aedd2b"];
                if (!testDef) {
                    this.si_profile_education_description_initially_hidden_tstValue_ = -1;
                } else {
                    this.si_profile_education_description_initially_hidden_tstValue_ = testDef[0];
                }
                testDef = opt_values["addcb71e6422f6e14c412ca51c44bc3399cdd7d5146c6c5b8eb4e8d7a4486872"];
                if (!testDef) {
                    this.prof_auto_resume_sections_schema_tstValue_ = -1;
                } else {
                    this.prof_auto_resume_sections_schema_tstValue_ = testDef[0];
                }
                testDef = opt_values["8d66f0e33a616af8176e89e2d9c5a8748d1cfa0da7f440ccaf9afb49e8f52235"];
                if (!testDef) {
                    this.pow_redesign_locale_pickerValue_ = -1;
                } else {
                    this.pow_redesign_locale_pickerValue_ = testDef[0];
                }
                testDef = opt_values["6d1c625071c3c9989e885798badc76a9c5704bfefc95a0e83161b7a57504ff22"];
                if (!testDef) {
                    this.prof_sg_work_auth_for_parsed_rez_tstValue_ = -1;
                } else {
                    this.prof_sg_work_auth_for_parsed_rez_tstValue_ = testDef[0];
                }
                testDef = opt_values["82cd2debeb731c53603c847d89ae10fe17bb473dcbd5f5f23719fd0ff66fe27f"];
                if (!testDef) {
                    this.pcs_qualifications_disclaimerValue_ = -1;
                } else {
                    this.pcs_qualifications_disclaimerValue_ = testDef[0];
                }
                testDef = opt_values["94036da13ad2f87b6489e78ba595e40092a377c5c14db743e03186a151166b18"];
                if (!testDef) {
                    this.pow_multiple_resume_tstValue_ = -1;
                } else {
                    this.pow_multiple_resume_tstValue_ = testDef[0];
                }
                testDef = opt_values["a90610425144f940f9f6e129e69795691ed71125106b9ccd9f11802e7aa13376"];
                if (!testDef) {
                    this.prof_tabbed_expValue_ = -1;
                } else {
                    this.prof_tabbed_expValue_ = testDef[0];
                }
                testDef = opt_values["ce49087491454bcad8869df4b80b1339d1b3224674041ae1ac7130eb6ac6d7e3"];
                if (!testDef) {
                    this.profile_extracted_qualifications_tstValue_ = -1;
                } else {
                    this.profile_extracted_qualifications_tstValue_ = testDef[0];
                }
                testDef = opt_values["ca6b8f0a46d3e592c8e12602f6115bacf704e1cdf5c429da41a4003249723937"];
                if (!testDef) {
                    this.in_resume_upload_profile_missing_info_tstValue_ = -1;
                } else {
                    this.in_resume_upload_profile_missing_info_tstValue_ = testDef[0];
                }
                testDef = opt_values["2cd6b57798b91fa3e93a296f769de79ce37ccf74731ffe08f9fc443bbb20874f"];
                if (!testDef) {
                    this.pow_edu_training_representation_splitValue_ = -1;
                } else {
                    this.pow_edu_training_representation_splitValue_ = testDef[0];
                }
                testDef = opt_values["58e46206cefff0ad0345b026a6702e4d7c13e3ad11e68a9572074d4e27525d08"];
                if (!testDef) {
                    this.prof_data_merge_parsed_resume_tstValue_ = -1;
                } else {
                    this.prof_data_merge_parsed_resume_tstValue_ = testDef[0];
                }
                testDef = opt_values["510e518caee82abddc6bd751c7166055cc6e72ef41e1c4d8d4f753cb6e4d17a6"];
                if (!testDef) {
                    this.prof_preference_improvement_toggleValue_ = -1;
                } else {
                    this.prof_preference_improvement_toggleValue_ = testDef[0];
                }
                testDef = opt_values["44a1f8ef6b11bc6bc5ec70a5a2c43f7486abec39c0d30590887e74852605e9d0"];
                if (!testDef) {
                    this.rdp_modernizationValue_ = -1;
                } else {
                    this.rdp_modernizationValue_ = testDef[0];
                }
                testDef = opt_values["ba528da9aeaede1d1f52493bad8eb3438828467170b68afb09ab77c12aee2a26"];
                if (!testDef) {
                    this.pow_crowtaxo_disclosure_tstValue_ = -1;
                } else {
                    this.pow_crowtaxo_disclosure_tstValue_ = testDef[0];
                }
                testDef = opt_values["858b11683dab412e9015dbcce05e087aa7c961e3bcd32d4e8248c868f74225a8"];
                if (!testDef) {
                    this.profile_title_match_autocomplete_dataset_tstValue_ = -1;
                    this.profile_title_match_autocomplete_dataset_tstPayloadValue_ = {};
                } else {
                    this.profile_title_match_autocomplete_dataset_tstValue_ = testDef[0];
                    this.profile_title_match_autocomplete_dataset_tstPayloadValue_ = testDef[1];
                }
                testDef = opt_values["433eb615cce00e8f80a5291a9240b3d509c1ee058c174d965d74eadc1d8e5f6b"];
                if (!testDef) {
                    this.in_resume_builder_language_proficiency_pageValue_ = -1;
                } else {
                    this.in_resume_builder_language_proficiency_pageValue_ = testDef[0];
                }
                testDef = opt_values["de42ca5f044174ced7bf68d349f5ed1cd7ed97970cff4833b0f19642766baf60"];
                if (!testDef) {
                    this.prof_upload_file_redaction_tstValue_ = -1;
                } else {
                    this.prof_upload_file_redaction_tstValue_ = testDef[0];
                }
                testDef = opt_values["50a7535a706bfb01b695b27306c733c3cde9b9531ea3e8cbbb443ddd125752ba"];
                if (!testDef) {
                    this.intl_non_pdf_searchability_lockValue_ = -1;
                } else {
                    this.intl_non_pdf_searchability_lockValue_ = testDef[0];
                }
                testDef = opt_values["582b1280fb8d92916da7713064f2bf9d321fc2b7d2656c86253688988341f568"];
                if (!testDef) {
                    this.prof_rdi_single_page_togValue_ = -1;
                } else {
                    this.prof_rdi_single_page_togValue_ = testDef[0];
                }
                testDef = opt_values["d8524b544dca190e1ccc8ce9922c996f70f55018ddd54fd0ce91da3806e5849b"];
                if (!testDef) {
                    this.prof_jp_no_thumbnailValue_ = -1;
                } else {
                    this.prof_jp_no_thumbnailValue_ = testDef[0];
                }
                testDef = opt_values["ae28a58ef2476611533ea52fc806d073b3ddb3d63498bf087163ccddda17ab5b"];
                if (!testDef) {
                    this.jpmp_jsg_pow_rng_promo_tstValue_ = -1;
                } else {
                    this.jpmp_jsg_pow_rng_promo_tstValue_ = testDef[0];
                }
                testDef = opt_values["076e45025137809500d8e23f50c7342181575476b63b0da99b99009cd1463753"];
                if (!testDef) {
                    this.prof_employer_blocking_sourcing_opt_inValue_ = -1;
                } else {
                    this.prof_employer_blocking_sourcing_opt_inValue_ = testDef[0];
                }
                testDef = opt_values["9316be7f4bc61683d4fd21e2864f4ad52e9f8564e29aaeab750f292a8ae8227d"];
                if (!testDef) {
                    this.pow_languages_field_migrationValue_ = -1;
                } else {
                    this.pow_languages_field_migrationValue_ = testDef[0];
                }
                testDef = opt_values["d6189977e40053cf39838cfb3180e881a94318eada23438032eff1ba15998021"];
                if (!testDef) {
                    this.myindallowfileonlytoggleValue_ = -1;
                } else {
                    this.myindallowfileonlytoggleValue_ = testDef[0];
                }
                testDef = opt_values["dfcfe4f5b59638758ee7d0056dbc984f7c7342c8a8711eadc5033f78ef057139"];
                if (!testDef) {
                    this.jp_match_myoffers_guide_copy_changeValue_ = -1;
                } else {
                    this.jp_match_myoffers_guide_copy_changeValue_ = testDef[0];
                }
                testDef = opt_values["fa9779bff1215de965e0d33a5779ad1c427763c6d28fc8245c7a99234a3f6f13"];
                if (!testDef) {
                    this.jpmp_jsg_use_jobseeker_raw_location_togValue_ = -1;
                } else {
                    this.jpmp_jsg_use_jobseeker_raw_location_togValue_ = testDef[0];
                }
                testDef = opt_values["47f307f043c8e599c2fec5d7546327eb78f566b30007466367b7b722a0991c8d"];
                if (!testDef) {
                    this.jpm_updated_communication_policy_togValue_ = -1;
                } else {
                    this.jpm_updated_communication_policy_togValue_ = testDef[0];
                }
                testDef = opt_values["dd301f9c1a9d7bbbae39df52d2aeeb2bf03e5bbb6ed6a51c11a5fec06a5eff57"];
                if (!testDef) {
                    this.profauto_doc_to_pdf_conversion_tstValue_ = -1;
                } else {
                    this.profauto_doc_to_pdf_conversion_tstValue_ = testDef[0];
                }
                testDef = opt_values["26636867e49724d20b230aff71b5e901fe0ddcd5f09137302447e295b2c38112"];
                if (!testDef) {
                    this.prof_remove_convert_to_indeed_resume_optionValue_ = -1;
                } else {
                    this.prof_remove_convert_to_indeed_resume_optionValue_ = testDef[0];
                }
                testDef = opt_values["56449a714b437d889ef264a7d362a5d6a1cf710cff0e63590b7a88c10cf29c4f"];
                if (!testDef) {
                    this.rdp_modernization_powValue_ = -1;
                } else {
                    this.rdp_modernization_powValue_ = testDef[0];
                }
                testDef = opt_values["e42bcae6e45c57c93b7d7cc57d3624da9d557e3c7e9fc7b98130083b62551a06"];
                if (!testDef) {
                    this.profile_phone_simplificationValue_ = -1;
                } else {
                    this.profile_phone_simplificationValue_ = testDef[0];
                }
                testDef = opt_values["8cd959ddae221592df2558e53d90966f72c962889c0d4505327295989f03b1f9"];
                if (!testDef) {
                    this.iosnative_rich_profilesValue_ = -1;
                } else {
                    this.iosnative_rich_profilesValue_ = testDef[0];
                }
                testDef = opt_values["b68c5a30bd730bf2f24c0ef68828eac410b7392c2374f4a6e3cf1a9ba9c0725c"];
                if (!testDef) {
                    this.re_upload_to_replaceValue_ = -1;
                } else {
                    this.re_upload_to_replaceValue_ = testDef[0];
                }
                testDef = opt_values["e47ad7b8fa86489a26b1567d870ba283330e7c15593e87834c0d7f53f046e551"];
                if (!testDef) {
                    this.jsu_profile_location_component_tstValue_ = -1;
                    this.jsu_profile_location_component_tstPayloadValue_ = {};
                } else {
                    this.jsu_profile_location_component_tstValue_ = testDef[0];
                    this.jsu_profile_location_component_tstPayloadValue_ = testDef[1];
                }
                testDef = opt_values["b7ab07f9747a0d43be1b9edcc0f717fd1b28d88fa2809e4e08ad8b223cdfe0ef"];
                if (!testDef) {
                    this.pow_intl_fields_resume_localeValue_ = -1;
                } else {
                    this.pow_intl_fields_resume_localeValue_ = testDef[0];
                }
                testDef = opt_values["c1d20ab5853e06edddd3d0eb356aec05265a63896a6d8b0139ff4c4409003b1d"];
                if (!testDef) {
                    this.profile_one_datadog_rum_toggleValue_ = -1;
                } else {
                    this.profile_one_datadog_rum_toggleValue_ = testDef[0];
                }
                testDef = opt_values["6a6beea93477d78ce6c71b11b9ca59edfb03b58de52dc018fb1b829a3b114c02"];
                if (!testDef) {
                    this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstValue_ = -1;
                    this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstPayloadValue_ = {};
                } else {
                    this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstValue_ = testDef[0];
                    this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstPayloadValue_ = testDef[1];
                }
                testDef = opt_values["1ff8e74c66c16622c26105f463865c70a6716922172fd80e65430bbfab70d3df"];
                if (!testDef) {
                    this.pow_skills_validationValue_ = -1;
                } else {
                    this.pow_skills_validationValue_ = testDef[0];
                }
                testDef = opt_values["e8023a1ac7d8690f7e7adfd5e7d5560c1af8c2d1b10ed8f70b6b9ef034de3470"];
                if (!testDef) {
                    this.jp_public_resume_optin_copy_tstValue_ = -1;
                } else {
                    this.jp_public_resume_optin_copy_tstValue_ = testDef[0];
                }
                testDef = opt_values["8e4134be7b4ff86bb4bab0357fc6562892f0ec233860a15be100b6794a707d9d"];
                if (!testDef) {
                    this.profile_update_app_banner_togValue_ = -1;
                } else {
                    this.profile_update_app_banner_togValue_ = testDef[0];
                }
                testDef = opt_values["64680ba4b32c5df65822f4a35a1663cea079175aafa0cc8c1500e950d1ce2344"];
                if (!testDef) {
                    this.profile_photos_togValue_ = -1;
                } else {
                    this.profile_photos_togValue_ = testDef[0];
                }
                testDef = opt_values["3b6ea3befac4fd788fd11a54067aaf85e9c2057ac49d4529394bd1554147927a"];
                if (!testDef) {
                    this.pow_hiredsignal_sourceability_toggle_tstValue_ = -1;
                } else {
                    this.pow_hiredsignal_sourceability_toggle_tstValue_ = testDef[0];
                }
                testDef = opt_values["de79ea17c5aee44e50f85676ced86334de5c6f2cbf83892e7db1e62e63a0a5e7"];
                if (!testDef) {
                    this.prof_fe_merge_second_phaseValue_ = -1;
                } else {
                    this.prof_fe_merge_second_phaseValue_ = testDef[0];
                }
                testDef = opt_values["c49ab16dbb1541ff761feb7c1876510886d365772fb7c909dbf82050ed0e3cd4"];
                if (!testDef) {
                    this.pet_cpra_donotsellsharelink_tstValue_ = -1;
                } else {
                    this.pet_cpra_donotsellsharelink_tstValue_ = testDef[0];
                }
                testDef = opt_values["dda635bb67ccd95426db42d6c989e1c647c5b21c97a79220bb6f91912113ee94"];
                if (!testDef) {
                    this.prof_tabbed_exp_smiley_surveyValue_ = -1;
                } else {
                    this.prof_tabbed_exp_smiley_surveyValue_ = testDef[0];
                }
            }
        } else {
            this.hiredsignal_resume_autocomplete_tstValue_ = -1;
            this.ia_override_native_app_cancel_button_tstValue_ = -1;
            this.in_resume_builder_certificationValue_ = -1;
            this.in_resume_builder_language_proficiency_pageValue_ = -1;
            this.in_resume_upload_profile_missing_info_tstValue_ = -1;
            this.intl_non_pdf_searchability_lockValue_ = -1;
            this.iosnative_premium_profile_insightsValue_ = -1;
            this.iosnative_rich_profilesValue_ = -1;
            this.jp_match_myoffers_guide_copy_changeValue_ = -1;
            this.jp_public_resume_optin_copy_tstValue_ = -1;
            this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstValue_ = -1;
            this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstPayloadValue_ = {};
            this.jpm_updated_communication_policy_togValue_ = -1;
            this.jpmp_jsg_pow_rag_promo_tstValue_ = -1;
            this.jpmp_jsg_pow_rag_promo_tstPayloadValue_ = {};
            this.jpmp_jsg_pow_rng_promo_tstValue_ = -1;
            this.jpmp_jsg_use_jobseeker_raw_location_togValue_ = -1;
            this.js_pro_actionable_checklist_tstValue_ = -1;
            this.js_pro_auto_apply_pow_tstValue_ = -1;
            this.js_pro_profile_enhancements_tstValue_ = -1;
            this.jsj_crowtaxo_holdout_tstValue_ = -1;
            this.jso_minimal_onboarding_tstValue_ = -1;
            this.jso_onboarding_jsf_tstValue_ = -1;
            this.jsu_employer_blocking_tstValue_ = -1;
            this.jsu_profile_location_component_tstValue_ = -1;
            this.jsu_profile_location_component_tstPayloadValue_ = {};
            this.mosaic_js_premium_parent_tstValue_ = -1;
            this.myindallowfileonlytoggleValue_ = -1;
            this.myindresumebuildertstValue_ = -1;
            this.pcs_qualifications_disclaimerValue_ = -1;
            this.pet_cpra_donotsellsharelink_tstValue_ = -1;
            this.pow_create_merged_profiles_tstValue_ = -1;
            this.pow_crowtaxo_disclosure_tstValue_ = -1;
            this.pow_current_salary_page_mvr_builderValue_ = -1;
            this.pow_edu_training_representation_splitValue_ = -1;
            this.pow_employment_eligibility_tstValue_ = -1;
            this.pow_europe_builder_flow_tstValue_ = -1;
            this.pow_first_last_name_validationValue_ = -1;
            this.pow_hiredsignal_sourceability_toggle_tstValue_ = -1;
            this.pow_intl_fields_resume_localeValue_ = -1;
            this.pow_languages_field_migrationValue_ = -1;
            this.pow_multiple_resume_tstValue_ = -1;
            this.pow_override_native_app_cancel_button_tstValue_ = -1;
            this.pow_phone_page_mvr_builderValue_ = -1;
            this.pow_privacy_promo_tstValue_ = -1;
            this.pow_re_resume_localeValue_ = -1;
            this.pow_redesign_locale_pickerValue_ = -1;
            this.pow_reusable_pay_component_tstValue_ = -1;
            this.pow_skills_test_deprecationValue_ = -1;
            this.pow_skills_validationValue_ = -1;
            this.prof_auto_resume_sections_schema_tstValue_ = -1;
            this.prof_completion_widgetValue_ = -1;
            this.prof_data_merge_parsed_resume_tstValue_ = -1;
            this.prof_employer_blocking_sourcing_opt_inValue_ = -1;
            this.prof_fe_merge_second_phaseValue_ = -1;
            this.prof_jp_no_thumbnailValue_ = -1;
            this.prof_mvp_data_merge_crowtaxo_togValue_ = -1;
            this.prof_mvp_data_merge_crowtaxo_togPayloadValue_ = {};
            this.prof_pdf_confirmationValue_ = -1;
            this.prof_preference_improvement_toggleValue_ = -1;
            this.prof_rdi_auto_merge_alert_togValue_ = -1;
            this.prof_rdi_single_page_togValue_ = -1;
            this.prof_remove_convert_to_indeed_resume_optionValue_ = -1;
            this.prof_rn_two_tabValue_ = -1;
            this.prof_sg_work_auth_for_parsed_rez_tstValue_ = -1;
            this.prof_tabbed_expValue_ = -1;
            this.prof_tabbed_exp_resume_data_importValue_ = -1;
            this.prof_tabbed_exp_smiley_surveyValue_ = -1;
            this.prof_upload_file_redaction_tstValue_ = -1;
            this.profauto_doc_to_pdf_conversion_tstValue_ = -1;
            this.profauto_pow_commute_time_tstValue_ = -1;
            this.profile_ai_summary_tstValue_ = -1;
            this.profile_ai_work_description_tstValue_ = -1;
            this.profile_extracted_qualifications_tstValue_ = -1;
            this.profile_one_csp_mode_togValue_ = -1;
            this.profile_one_datadog_rum_toggleValue_ = -1;
            this.profile_one_fullstory_tstValue_ = -1;
            this.profile_one_redesign_preferences_tstValue_ = -1;
            this.profile_phone_simplificationValue_ = -1;
            this.profile_photos_togValue_ = -1;
            this.profile_score_tstValue_ = -1;
            this.profile_text_experience_input_tstValue_ = -1;
            this.profile_title_match_autocomplete_dataset_tstValue_ = -1;
            this.profile_title_match_autocomplete_dataset_tstPayloadValue_ = {};
            this.profile_update_app_banner_togValue_ = -1;
            this.profile_yoe_removal_togValue_ = -1;
            this.rdp_modernizationValue_ = -1;
            this.rdp_modernization_powValue_ = -1;
            this.rdp_pdf_resume_faceliftValue_ = -1;
            this.re_upload_to_replaceValue_ = -1;
            this.si_profile_education_description_initially_hidden_tstValue_ = -1;
        }
    };


  // HIREDSIGNAL_RESUME_AUTOCOMPLETE_TST


  /**
   * Bucket value for hiredsignal_resume_autocomplete_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.hiredsignal_resume_autocomplete_tstValue_;




  /**
   * Checks if the user is in hiredsignal_resume_autocomplete_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isHiredsignal_resume_autocomplete_tstInactive = function() {
    return this.hiredsignal_resume_autocomplete_tstValue_ === -1;
  };


  /**
   * Checks if the user is in hiredsignal_resume_autocomplete_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isHiredsignal_resume_autocomplete_tstControl = function() {
    return this.hiredsignal_resume_autocomplete_tstValue_ === 0;
  };


  /**
   * Checks if the user is in hiredsignal_resume_autocomplete_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isHiredsignal_resume_autocomplete_tstTest = function() {
    return this.hiredsignal_resume_autocomplete_tstValue_ === 1;
  };



  // IA_OVERRIDE_NATIVE_APP_CANCEL_BUTTON_TST


  /**
   * Bucket value for ia_override_native_app_cancel_button_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.ia_override_native_app_cancel_button_tstValue_;




  /**
   * Checks if the user is in ia_override_native_app_cancel_button_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIa_override_native_app_cancel_button_tstInactive = function() {
    return this.ia_override_native_app_cancel_button_tstValue_ === -1;
  };


  /**
   * Checks if the user is in ia_override_native_app_cancel_button_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIa_override_native_app_cancel_button_tstControl = function() {
    return this.ia_override_native_app_cancel_button_tstValue_ === 0;
  };


  /**
   * Checks if the user is in ia_override_native_app_cancel_button_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIa_override_native_app_cancel_button_tstTest = function() {
    return this.ia_override_native_app_cancel_button_tstValue_ === 1;
  };



  // IN_RESUME_BUILDER_CERTIFICATION


  /**
   * Bucket value for in_resume_builder_certification.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.in_resume_builder_certificationValue_;




  /**
   * Checks if the user is in in_resume_builder_certificationInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_certificationInactive = function() {
    return this.in_resume_builder_certificationValue_ === -1;
  };


  /**
   * Checks if the user is in in_resume_builder_certificationControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_certificationControl = function() {
    return this.in_resume_builder_certificationValue_ === 0;
  };


  /**
   * Checks if the user is in in_resume_builder_certificationGrp1.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_certificationGrp1 = function() {
    return this.in_resume_builder_certificationValue_ === 1;
  };



  // IN_RESUME_BUILDER_LANGUAGE_PROFICIENCY_PAGE


  /**
   * Bucket value for in_resume_builder_language_proficiency_page.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.in_resume_builder_language_proficiency_pageValue_;




  /**
   * Checks if the user is in in_resume_builder_language_proficiency_pageInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_language_proficiency_pageInactive = function() {
    return this.in_resume_builder_language_proficiency_pageValue_ === -1;
  };


  /**
   * Checks if the user is in in_resume_builder_language_proficiency_pageControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_language_proficiency_pageControl = function() {
    return this.in_resume_builder_language_proficiency_pageValue_ === 0;
  };


  /**
   * Checks if the user is in in_resume_builder_language_proficiency_pageGrp1.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_language_proficiency_pageGrp1 = function() {
    return this.in_resume_builder_language_proficiency_pageValue_ === 1;
  };


  /**
   * Checks if the user is in in_resume_builder_language_proficiency_pageGrp2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_language_proficiency_pageGrp2 = function() {
    return this.in_resume_builder_language_proficiency_pageValue_ === 2;
  };



  // IN_RESUME_UPLOAD_PROFILE_MISSING_INFO_TST


  /**
   * Bucket value for in_resume_upload_profile_missing_info_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.in_resume_upload_profile_missing_info_tstValue_;




  /**
   * Checks if the user is in in_resume_upload_profile_missing_info_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_upload_profile_missing_info_tstInactive = function() {
    return this.in_resume_upload_profile_missing_info_tstValue_ === -1;
  };


  /**
   * Checks if the user is in in_resume_upload_profile_missing_info_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_upload_profile_missing_info_tstControl = function() {
    return this.in_resume_upload_profile_missing_info_tstValue_ === 0;
  };


  /**
   * Checks if the user is in in_resume_upload_profile_missing_info_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_upload_profile_missing_info_tstTest = function() {
    return this.in_resume_upload_profile_missing_info_tstValue_ === 1;
  };



  // INTL_NON_PDF_SEARCHABILITY_LOCK


  /**
   * Bucket value for intl_non_pdf_searchability_lock.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.intl_non_pdf_searchability_lockValue_;




  /**
   * Checks if the user is in intl_non_pdf_searchability_lockInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIntl_non_pdf_searchability_lockInactive = function() {
    return this.intl_non_pdf_searchability_lockValue_ === -1;
  };


  /**
   * Checks if the user is in intl_non_pdf_searchability_lockControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIntl_non_pdf_searchability_lockControl = function() {
    return this.intl_non_pdf_searchability_lockValue_ === 0;
  };


  /**
   * Checks if the user is in intl_non_pdf_searchability_lockActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIntl_non_pdf_searchability_lockActive = function() {
    return this.intl_non_pdf_searchability_lockValue_ === 1;
  };



  // IOSNATIVE_PREMIUM_PROFILE_INSIGHTS


  /**
   * Bucket value for iosnative_premium_profile_insights.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.iosnative_premium_profile_insightsValue_;




  /**
   * Checks if the user is in iosnative_premium_profile_insightsInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsInactive = function() {
    return this.iosnative_premium_profile_insightsValue_ === -1;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsControl = function() {
    return this.iosnative_premium_profile_insightsValue_ === 0;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsControl_aa.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsControl_aa = function() {
    return this.iosnative_premium_profile_insightsValue_ === 1;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsActive = function() {
    return this.iosnative_premium_profile_insightsValue_ === 2;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsPremium_branding.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsPremium_branding = function() {
    return this.iosnative_premium_profile_insightsValue_ === 3;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsPhase_b_control.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsPhase_b_control = function() {
    return this.iosnative_premium_profile_insightsValue_ === 4;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsPhase_b.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsPhase_b = function() {
    return this.iosnative_premium_profile_insightsValue_ === 5;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsPhase_c_control.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsPhase_c_control = function() {
    return this.iosnative_premium_profile_insightsValue_ === 6;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsPhase_c.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsPhase_c = function() {
    return this.iosnative_premium_profile_insightsValue_ === 7;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsReserved_f.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsReserved_f = function() {
    return this.iosnative_premium_profile_insightsValue_ === 8;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsReserved_g.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsReserved_g = function() {
    return this.iosnative_premium_profile_insightsValue_ === 9;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsReserved_h.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsReserved_h = function() {
    return this.iosnative_premium_profile_insightsValue_ === 10;
  };



  // IOSNATIVE_RICH_PROFILES


  /**
   * Bucket value for iosnative_rich_profiles.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.iosnative_rich_profilesValue_;




  /**
   * Checks if the user is in iosnative_rich_profilesInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesInactive = function() {
    return this.iosnative_rich_profilesValue_ === -1;
  };


  /**
   * Checks if the user is in iosnative_rich_profilesControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesControl = function() {
    return this.iosnative_rich_profilesValue_ === 0;
  };


  /**
   * Checks if the user is in iosnative_rich_profilesControl_aa.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesControl_aa = function() {
    return this.iosnative_rich_profilesValue_ === 1;
  };


  /**
   * Checks if the user is in iosnative_rich_profilesPhase_a_active.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesPhase_a_active = function() {
    return this.iosnative_rich_profilesValue_ === 2;
  };


  /**
   * Checks if the user is in iosnative_rich_profilesPhase_a_reserved.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesPhase_a_reserved = function() {
    return this.iosnative_rich_profilesValue_ === 3;
  };


  /**
   * Checks if the user is in iosnative_rich_profilesTaxonomy_fetch_control.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesTaxonomy_fetch_control = function() {
    return this.iosnative_rich_profilesValue_ === 4;
  };


  /**
   * Checks if the user is in iosnative_rich_profilesTaxonomy_fetch.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesTaxonomy_fetch = function() {
    return this.iosnative_rich_profilesValue_ === 5;
  };


  /**
   * Checks if the user is in iosnative_rich_profilesReserved_c_control.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesReserved_c_control = function() {
    return this.iosnative_rich_profilesValue_ === 6;
  };


  /**
   * Checks if the user is in iosnative_rich_profilesReserved_c.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesReserved_c = function() {
    return this.iosnative_rich_profilesValue_ === 7;
  };


  /**
   * Checks if the user is in iosnative_rich_profilesReserved_d_control.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesReserved_d_control = function() {
    return this.iosnative_rich_profilesValue_ === 8;
  };


  /**
   * Checks if the user is in iosnative_rich_profilesReserved_d.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesReserved_d = function() {
    return this.iosnative_rich_profilesValue_ === 9;
  };



  // JP_MATCH_MYOFFERS_GUIDE_COPY_CHANGE


  /**
   * Bucket value for jp_match_myoffers_guide_copy_change.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jp_match_myoffers_guide_copy_changeValue_;




  /**
   * Checks if the user is in jp_match_myoffers_guide_copy_changeInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJp_match_myoffers_guide_copy_changeInactive = function() {
    return this.jp_match_myoffers_guide_copy_changeValue_ === -1;
  };


  /**
   * Checks if the user is in jp_match_myoffers_guide_copy_changeControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJp_match_myoffers_guide_copy_changeControl = function() {
    return this.jp_match_myoffers_guide_copy_changeValue_ === 0;
  };


  /**
   * Checks if the user is in jp_match_myoffers_guide_copy_changeTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJp_match_myoffers_guide_copy_changeTest = function() {
    return this.jp_match_myoffers_guide_copy_changeValue_ === 1;
  };



  // JP_PUBLIC_RESUME_OPTIN_COPY_TST


  /**
   * Bucket value for jp_public_resume_optin_copy_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jp_public_resume_optin_copy_tstValue_;




  /**
   * Checks if the user is in jp_public_resume_optin_copy_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJp_public_resume_optin_copy_tstInactive = function() {
    return this.jp_public_resume_optin_copy_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jp_public_resume_optin_copy_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJp_public_resume_optin_copy_tstControl = function() {
    return this.jp_public_resume_optin_copy_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jp_public_resume_optin_copy_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJp_public_resume_optin_copy_tstTest = function() {
    return this.jp_public_resume_optin_copy_tstValue_ === 1;
  };



  // JPE_CROWTAGS_RESUME_FLOW_OCCUPATION_AUTOSUGGESTION_TST


  /**
   * Bucket value for jpe_crowtags_resume_flow_occupation_autosuggestion_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jpe_crowtags_resume_flow_occupation_autosuggestion_tstValue_;


  /**
   * Payload value for jpe_crowtags_resume_flow_occupation_autosuggestion_tst.
   * @type {Object}
   * @private
   */
  ProfileProctorGroups_.prototype.jpe_crowtags_resume_flow_occupation_autosuggestion_tstPayloadValue_;


  /**
   * Get the payload value for jpe_crowtags_resume_flow_occupation_autosuggestion_tst.
   * @return {Object}
   */
  ProfileProctorGroups_.prototype.getJpe_crowtags_resume_flow_occupation_autosuggestion_tstPayloadValue = function() {
    return this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstPayloadValue_;
  };


  /**
   * Checks if the user is in jpe_crowtags_resume_flow_occupation_autosuggestion_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpe_crowtags_resume_flow_occupation_autosuggestion_tstInactive = function() {
    return this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jpe_crowtags_resume_flow_occupation_autosuggestion_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpe_crowtags_resume_flow_occupation_autosuggestion_tstControl = function() {
    return this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jpe_crowtags_resume_flow_occupation_autosuggestion_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpe_crowtags_resume_flow_occupation_autosuggestion_tstTest = function() {
    return this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstValue_ === 1;
  };



  // JPM_UPDATED_COMMUNICATION_POLICY_TOG


  /**
   * Bucket value for jpm_updated_communication_policy_tog.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jpm_updated_communication_policy_togValue_;




  /**
   * Checks if the user is in jpm_updated_communication_policy_togInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpm_updated_communication_policy_togInactive = function() {
    return this.jpm_updated_communication_policy_togValue_ === -1;
  };


  /**
   * Checks if the user is in jpm_updated_communication_policy_togControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpm_updated_communication_policy_togControl = function() {
    return this.jpm_updated_communication_policy_togValue_ === 0;
  };


  /**
   * Checks if the user is in jpm_updated_communication_policy_togTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpm_updated_communication_policy_togTest = function() {
    return this.jpm_updated_communication_policy_togValue_ === 1;
  };



  // JPMP_JSG_POW_RAG_PROMO_TST


  /**
   * Bucket value for jpmp_jsg_pow_rag_promo_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jpmp_jsg_pow_rag_promo_tstValue_;


  /**
   * Payload value for jpmp_jsg_pow_rag_promo_tst.
   * @type {Object}
   * @private
   */
  ProfileProctorGroups_.prototype.jpmp_jsg_pow_rag_promo_tstPayloadValue_;


  /**
   * Get the payload value for jpmp_jsg_pow_rag_promo_tst.
   * @return {Object}
   */
  ProfileProctorGroups_.prototype.getJpmp_jsg_pow_rag_promo_tstPayloadValue = function() {
    return this.jpmp_jsg_pow_rag_promo_tstPayloadValue_;
  };


  /**
   * Checks if the user is in jpmp_jsg_pow_rag_promo_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_pow_rag_promo_tstInactive = function() {
    return this.jpmp_jsg_pow_rag_promo_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jpmp_jsg_pow_rag_promo_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_pow_rag_promo_tstControl = function() {
    return this.jpmp_jsg_pow_rag_promo_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jpmp_jsg_pow_rag_promo_tstFulltimeShort.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_pow_rag_promo_tstFulltimeShort = function() {
    return this.jpmp_jsg_pow_rag_promo_tstValue_ === 1;
  };


  /**
   * Checks if the user is in jpmp_jsg_pow_rag_promo_tstAllShort.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_pow_rag_promo_tstAllShort = function() {
    return this.jpmp_jsg_pow_rag_promo_tstValue_ === 2;
  };


  /**
   * Checks if the user is in jpmp_jsg_pow_rag_promo_tstFulltimeLong.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_pow_rag_promo_tstFulltimeLong = function() {
    return this.jpmp_jsg_pow_rag_promo_tstValue_ === 3;
  };


  /**
   * Checks if the user is in jpmp_jsg_pow_rag_promo_tstAllLong.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_pow_rag_promo_tstAllLong = function() {
    return this.jpmp_jsg_pow_rag_promo_tstValue_ === 4;
  };



  // JPMP_JSG_POW_RNG_PROMO_TST


  /**
   * Bucket value for jpmp_jsg_pow_rng_promo_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jpmp_jsg_pow_rng_promo_tstValue_;




  /**
   * Checks if the user is in jpmp_jsg_pow_rng_promo_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_pow_rng_promo_tstInactive = function() {
    return this.jpmp_jsg_pow_rng_promo_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jpmp_jsg_pow_rng_promo_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_pow_rng_promo_tstControl = function() {
    return this.jpmp_jsg_pow_rng_promo_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jpmp_jsg_pow_rng_promo_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_pow_rng_promo_tstTest = function() {
    return this.jpmp_jsg_pow_rng_promo_tstValue_ === 1;
  };



  // JPMP_JSG_USE_JOBSEEKER_RAW_LOCATION_TOG


  /**
   * Bucket value for jpmp_jsg_use_jobseeker_raw_location_tog.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jpmp_jsg_use_jobseeker_raw_location_togValue_;




  /**
   * Checks if the user is in jpmp_jsg_use_jobseeker_raw_location_togInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_use_jobseeker_raw_location_togInactive = function() {
    return this.jpmp_jsg_use_jobseeker_raw_location_togValue_ === -1;
  };


  /**
   * Checks if the user is in jpmp_jsg_use_jobseeker_raw_location_togControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_use_jobseeker_raw_location_togControl = function() {
    return this.jpmp_jsg_use_jobseeker_raw_location_togValue_ === 0;
  };


  /**
   * Checks if the user is in jpmp_jsg_use_jobseeker_raw_location_togTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_use_jobseeker_raw_location_togTest = function() {
    return this.jpmp_jsg_use_jobseeker_raw_location_togValue_ === 1;
  };



  // JS_PRO_ACTIONABLE_CHECKLIST_TST


  /**
   * Bucket value for js_pro_actionable_checklist_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.js_pro_actionable_checklist_tstValue_;




  /**
   * Checks if the user is in js_pro_actionable_checklist_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJs_pro_actionable_checklist_tstInactive = function() {
    return this.js_pro_actionable_checklist_tstValue_ === -1;
  };


  /**
   * Checks if the user is in js_pro_actionable_checklist_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJs_pro_actionable_checklist_tstControl = function() {
    return this.js_pro_actionable_checklist_tstValue_ === 0;
  };


  /**
   * Checks if the user is in js_pro_actionable_checklist_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJs_pro_actionable_checklist_tstTest = function() {
    return this.js_pro_actionable_checklist_tstValue_ === 1;
  };



  // JS_PRO_AUTO_APPLY_POW_TST


  /**
   * Bucket value for js_pro_auto_apply_pow_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.js_pro_auto_apply_pow_tstValue_;




  /**
   * Checks if the user is in js_pro_auto_apply_pow_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJs_pro_auto_apply_pow_tstInactive = function() {
    return this.js_pro_auto_apply_pow_tstValue_ === -1;
  };


  /**
   * Checks if the user is in js_pro_auto_apply_pow_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJs_pro_auto_apply_pow_tstControl = function() {
    return this.js_pro_auto_apply_pow_tstValue_ === 0;
  };


  /**
   * Checks if the user is in js_pro_auto_apply_pow_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJs_pro_auto_apply_pow_tstTest = function() {
    return this.js_pro_auto_apply_pow_tstValue_ === 1;
  };



  // JS_PRO_PROFILE_ENHANCEMENTS_TST


  /**
   * Bucket value for js_pro_profile_enhancements_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.js_pro_profile_enhancements_tstValue_;




  /**
   * Checks if the user is in js_pro_profile_enhancements_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJs_pro_profile_enhancements_tstInactive = function() {
    return this.js_pro_profile_enhancements_tstValue_ === -1;
  };


  /**
   * Checks if the user is in js_pro_profile_enhancements_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJs_pro_profile_enhancements_tstControl = function() {
    return this.js_pro_profile_enhancements_tstValue_ === 0;
  };


  /**
   * Checks if the user is in js_pro_profile_enhancements_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJs_pro_profile_enhancements_tstTest = function() {
    return this.js_pro_profile_enhancements_tstValue_ === 1;
  };



  // JSJ_CROWTAXO_HOLDOUT_TST


  /**
   * Bucket value for jsj_crowtaxo_holdout_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jsj_crowtaxo_holdout_tstValue_;




  /**
   * Checks if the user is in jsj_crowtaxo_holdout_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsj_crowtaxo_holdout_tstInactive = function() {
    return this.jsj_crowtaxo_holdout_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jsj_crowtaxo_holdout_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsj_crowtaxo_holdout_tstControl = function() {
    return this.jsj_crowtaxo_holdout_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jsj_crowtaxo_holdout_tstHoldout.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsj_crowtaxo_holdout_tstHoldout = function() {
    return this.jsj_crowtaxo_holdout_tstValue_ === 1;
  };


  /**
   * Checks if the user is in jsj_crowtaxo_holdout_tstCrowtaxo.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsj_crowtaxo_holdout_tstCrowtaxo = function() {
    return this.jsj_crowtaxo_holdout_tstValue_ === 2;
  };



  // JSO_MINIMAL_ONBOARDING_TST


  /**
   * Bucket value for jso_minimal_onboarding_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jso_minimal_onboarding_tstValue_;




  /**
   * Checks if the user is in jso_minimal_onboarding_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_minimal_onboarding_tstInactive = function() {
    return this.jso_minimal_onboarding_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jso_minimal_onboarding_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_minimal_onboarding_tstControl = function() {
    return this.jso_minimal_onboarding_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jso_minimal_onboarding_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_minimal_onboarding_tstTest = function() {
    return this.jso_minimal_onboarding_tstValue_ === 1;
  };


  /**
   * Checks if the user is in jso_minimal_onboarding_tstHomepageRedirect.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_minimal_onboarding_tstHomepageRedirect = function() {
    return this.jso_minimal_onboarding_tstValue_ === 2;
  };



  // JSO_ONBOARDING_JSF_TST


  /**
   * Bucket value for jso_onboarding_jsf_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jso_onboarding_jsf_tstValue_;




  /**
   * Checks if the user is in jso_onboarding_jsf_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_onboarding_jsf_tstInactive = function() {
    return this.jso_onboarding_jsf_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jso_onboarding_jsf_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_onboarding_jsf_tstControl = function() {
    return this.jso_onboarding_jsf_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jso_onboarding_jsf_tstJsfHosted.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_onboarding_jsf_tstJsfHosted = function() {
    return this.jso_onboarding_jsf_tstValue_ === 1;
  };



  // JSU_EMPLOYER_BLOCKING_TST


  /**
   * Bucket value for jsu_employer_blocking_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jsu_employer_blocking_tstValue_;




  /**
   * Checks if the user is in jsu_employer_blocking_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_employer_blocking_tstInactive = function() {
    return this.jsu_employer_blocking_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jsu_employer_blocking_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_employer_blocking_tstControl = function() {
    return this.jsu_employer_blocking_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jsu_employer_blocking_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_employer_blocking_tstTest = function() {
    return this.jsu_employer_blocking_tstValue_ === 1;
  };



  // JSU_PROFILE_LOCATION_COMPONENT_TST


  /**
   * Bucket value for jsu_profile_location_component_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jsu_profile_location_component_tstValue_;


  /**
   * Payload value for jsu_profile_location_component_tst.
   * @type {Object}
   * @private
   */
  ProfileProctorGroups_.prototype.jsu_profile_location_component_tstPayloadValue_;


  /**
   * Get the payload value for jsu_profile_location_component_tst.
   * @return {Object}
   */
  ProfileProctorGroups_.prototype.getJsu_profile_location_component_tstPayloadValue = function() {
    return this.jsu_profile_location_component_tstPayloadValue_;
  };


  /**
   * Checks if the user is in jsu_profile_location_component_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_profile_location_component_tstInactive = function() {
    return this.jsu_profile_location_component_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jsu_profile_location_component_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_profile_location_component_tstControl = function() {
    return this.jsu_profile_location_component_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jsu_profile_location_component_tstGrpIN.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_profile_location_component_tstGrpIN = function() {
    return this.jsu_profile_location_component_tstValue_ === 1;
  };


  /**
   * Checks if the user is in jsu_profile_location_component_tstGrpJP.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_profile_location_component_tstGrpJP = function() {
    return this.jsu_profile_location_component_tstValue_ === 2;
  };


  /**
   * Checks if the user is in jsu_profile_location_component_tstGrpA.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_profile_location_component_tstGrpA = function() {
    return this.jsu_profile_location_component_tstValue_ === 3;
  };


  /**
   * Checks if the user is in jsu_profile_location_component_tstGrpB.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_profile_location_component_tstGrpB = function() {
    return this.jsu_profile_location_component_tstValue_ === 4;
  };


  /**
   * Checks if the user is in jsu_profile_location_component_tstGrpC.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_profile_location_component_tstGrpC = function() {
    return this.jsu_profile_location_component_tstValue_ === 5;
  };


  /**
   * Checks if the user is in jsu_profile_location_component_tstResumeFlow.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_profile_location_component_tstResumeFlow = function() {
    return this.jsu_profile_location_component_tstValue_ === 6;
  };


  /**
   * Checks if the user is in jsu_profile_location_component_tstResumeFlowControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_profile_location_component_tstResumeFlowControl = function() {
    return this.jsu_profile_location_component_tstValue_ === 7;
  };



  // MOSAIC_JS_PREMIUM_PARENT_TST


  /**
   * Bucket value for mosaic_js_premium_parent_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.mosaic_js_premium_parent_tstValue_;




  /**
   * Checks if the user is in mosaic_js_premium_parent_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMosaic_js_premium_parent_tstInactive = function() {
    return this.mosaic_js_premium_parent_tstValue_ === -1;
  };


  /**
   * Checks if the user is in mosaic_js_premium_parent_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMosaic_js_premium_parent_tstControl = function() {
    return this.mosaic_js_premium_parent_tstValue_ === 0;
  };


  /**
   * Checks if the user is in mosaic_js_premium_parent_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMosaic_js_premium_parent_tstActive = function() {
    return this.mosaic_js_premium_parent_tstValue_ === 1;
  };



  // MYINDALLOWFILEONLYTOGGLE


  /**
   * Bucket value for myindallowfileonlytoggle.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.myindallowfileonlytoggleValue_;




  /**
   * Checks if the user is in myindallowfileonlytoggleInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindallowfileonlytoggleInactive = function() {
    return this.myindallowfileonlytoggleValue_ === -1;
  };


  /**
   * Checks if the user is in myindallowfileonlytoggleControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindallowfileonlytoggleControl = function() {
    return this.myindallowfileonlytoggleValue_ === 0;
  };


  /**
   * Checks if the user is in myindallowfileonlytoggleActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindallowfileonlytoggleActive = function() {
    return this.myindallowfileonlytoggleValue_ === 1;
  };


  /**
   * Checks if the user is in myindallowfileonlytoggleDefaultPublic.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindallowfileonlytoggleDefaultPublic = function() {
    return this.myindallowfileonlytoggleValue_ === 2;
  };


  /**
   * Checks if the user is in myindallowfileonlytoggleAutoPublic.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindallowfileonlytoggleAutoPublic = function() {
    return this.myindallowfileonlytoggleValue_ === 3;
  };


  /**
   * Checks if the user is in myindallowfileonlytoggleControlWithPrivacy.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindallowfileonlytoggleControlWithPrivacy = function() {
    return this.myindallowfileonlytoggleValue_ === 4;
  };



  // MYINDRESUMEBUILDERTST


  /**
   * Bucket value for myindresumebuildertst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.myindresumebuildertstValue_;




  /**
   * Checks if the user is in myindresumebuildertstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindresumebuildertstInactive = function() {
    return this.myindresumebuildertstValue_ === -1;
  };


  /**
   * Checks if the user is in myindresumebuildertstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindresumebuildertstControl = function() {
    return this.myindresumebuildertstValue_ === 0;
  };


  /**
   * Checks if the user is in myindresumebuildertstGrp1.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindresumebuildertstGrp1 = function() {
    return this.myindresumebuildertstValue_ === 1;
  };


  /**
   * Checks if the user is in myindresumebuildertstGrp2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindresumebuildertstGrp2 = function() {
    return this.myindresumebuildertstValue_ === 2;
  };


  /**
   * Checks if the user is in myindresumebuildertstGrp3.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindresumebuildertstGrp3 = function() {
    return this.myindresumebuildertstValue_ === 3;
  };



  // PCS_QUALIFICATIONS_DISCLAIMER


  /**
   * Bucket value for pcs_qualifications_disclaimer.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pcs_qualifications_disclaimerValue_;




  /**
   * Checks if the user is in pcs_qualifications_disclaimerInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPcs_qualifications_disclaimerInactive = function() {
    return this.pcs_qualifications_disclaimerValue_ === -1;
  };


  /**
   * Checks if the user is in pcs_qualifications_disclaimerControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPcs_qualifications_disclaimerControl = function() {
    return this.pcs_qualifications_disclaimerValue_ === 0;
  };


  /**
   * Checks if the user is in pcs_qualifications_disclaimerTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPcs_qualifications_disclaimerTest = function() {
    return this.pcs_qualifications_disclaimerValue_ === 1;
  };



  // PET_CPRA_DONOTSELLSHARELINK_TST


  /**
   * Bucket value for pet_cpra_donotsellsharelink_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pet_cpra_donotsellsharelink_tstValue_;




  /**
   * Checks if the user is in pet_cpra_donotsellsharelink_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPet_cpra_donotsellsharelink_tstInactive = function() {
    return this.pet_cpra_donotsellsharelink_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pet_cpra_donotsellsharelink_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPet_cpra_donotsellsharelink_tstActive = function() {
    return this.pet_cpra_donotsellsharelink_tstValue_ === 1;
  };



  // POW_CREATE_MERGED_PROFILES_TST


  /**
   * Bucket value for pow_create_merged_profiles_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_create_merged_profiles_tstValue_;




  /**
   * Checks if the user is in pow_create_merged_profiles_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_create_merged_profiles_tstInactive = function() {
    return this.pow_create_merged_profiles_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pow_create_merged_profiles_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_create_merged_profiles_tstControl = function() {
    return this.pow_create_merged_profiles_tstValue_ === 0;
  };


  /**
   * Checks if the user is in pow_create_merged_profiles_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_create_merged_profiles_tstTest = function() {
    return this.pow_create_merged_profiles_tstValue_ === 1;
  };



  // POW_CROWTAXO_DISCLOSURE_TST


  /**
   * Bucket value for pow_crowtaxo_disclosure_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_crowtaxo_disclosure_tstValue_;




  /**
   * Checks if the user is in pow_crowtaxo_disclosure_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_crowtaxo_disclosure_tstInactive = function() {
    return this.pow_crowtaxo_disclosure_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pow_crowtaxo_disclosure_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_crowtaxo_disclosure_tstControl = function() {
    return this.pow_crowtaxo_disclosure_tstValue_ === 0;
  };


  /**
   * Checks if the user is in pow_crowtaxo_disclosure_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_crowtaxo_disclosure_tstTest = function() {
    return this.pow_crowtaxo_disclosure_tstValue_ === 1;
  };



  // POW_CURRENT_SALARY_PAGE_MVR_BUILDER


  /**
   * Bucket value for pow_current_salary_page_mvr_builder.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_current_salary_page_mvr_builderValue_;




  /**
   * Checks if the user is in pow_current_salary_page_mvr_builderInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_current_salary_page_mvr_builderInactive = function() {
    return this.pow_current_salary_page_mvr_builderValue_ === -1;
  };


  /**
   * Checks if the user is in pow_current_salary_page_mvr_builderControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_current_salary_page_mvr_builderControl = function() {
    return this.pow_current_salary_page_mvr_builderValue_ === 0;
  };


  /**
   * Checks if the user is in pow_current_salary_page_mvr_builderTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_current_salary_page_mvr_builderTest = function() {
    return this.pow_current_salary_page_mvr_builderValue_ === 1;
  };



  // POW_EDU_TRAINING_REPRESENTATION_SPLIT


  /**
   * Bucket value for pow_edu_training_representation_split.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_edu_training_representation_splitValue_;




  /**
   * Checks if the user is in pow_edu_training_representation_splitInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_edu_training_representation_splitInactive = function() {
    return this.pow_edu_training_representation_splitValue_ === -1;
  };


  /**
   * Checks if the user is in pow_edu_training_representation_splitControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_edu_training_representation_splitControl = function() {
    return this.pow_edu_training_representation_splitValue_ === 0;
  };


  /**
   * Checks if the user is in pow_edu_training_representation_splitTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_edu_training_representation_splitTest = function() {
    return this.pow_edu_training_representation_splitValue_ === 1;
  };



  // POW_EMPLOYMENT_ELIGIBILITY_TST


  /**
   * Bucket value for pow_employment_eligibility_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_employment_eligibility_tstValue_;




  /**
   * Checks if the user is in pow_employment_eligibility_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_employment_eligibility_tstInactive = function() {
    return this.pow_employment_eligibility_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pow_employment_eligibility_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_employment_eligibility_tstControl = function() {
    return this.pow_employment_eligibility_tstValue_ === 0;
  };


  /**
   * Checks if the user is in pow_employment_eligibility_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_employment_eligibility_tstTest = function() {
    return this.pow_employment_eligibility_tstValue_ === 1;
  };


  /**
   * Checks if the user is in pow_employment_eligibility_tstGrp2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_employment_eligibility_tstGrp2 = function() {
    return this.pow_employment_eligibility_tstValue_ === 2;
  };



  // POW_EUROPE_BUILDER_FLOW_TST


  /**
   * Bucket value for pow_europe_builder_flow_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_europe_builder_flow_tstValue_;




  /**
   * Checks if the user is in pow_europe_builder_flow_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_europe_builder_flow_tstInactive = function() {
    return this.pow_europe_builder_flow_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pow_europe_builder_flow_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_europe_builder_flow_tstControl = function() {
    return this.pow_europe_builder_flow_tstValue_ === 0;
  };


  /**
   * Checks if the user is in pow_europe_builder_flow_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_europe_builder_flow_tstTest = function() {
    return this.pow_europe_builder_flow_tstValue_ === 1;
  };



  // POW_FIRST_LAST_NAME_VALIDATION


  /**
   * Bucket value for pow_first_last_name_validation.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_first_last_name_validationValue_;




  /**
   * Checks if the user is in pow_first_last_name_validationInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_first_last_name_validationInactive = function() {
    return this.pow_first_last_name_validationValue_ === -1;
  };


  /**
   * Checks if the user is in pow_first_last_name_validationControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_first_last_name_validationControl = function() {
    return this.pow_first_last_name_validationValue_ === 0;
  };


  /**
   * Checks if the user is in pow_first_last_name_validationTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_first_last_name_validationTest = function() {
    return this.pow_first_last_name_validationValue_ === 1;
  };



  // POW_HIREDSIGNAL_SOURCEABILITY_TOGGLE_TST


  /**
   * Bucket value for pow_hiredsignal_sourceability_toggle_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_hiredsignal_sourceability_toggle_tstValue_;




  /**
   * Checks if the user is in pow_hiredsignal_sourceability_toggle_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_hiredsignal_sourceability_toggle_tstInactive = function() {
    return this.pow_hiredsignal_sourceability_toggle_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pow_hiredsignal_sourceability_toggle_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_hiredsignal_sourceability_toggle_tstControl = function() {
    return this.pow_hiredsignal_sourceability_toggle_tstValue_ === 0;
  };


  /**
   * Checks if the user is in pow_hiredsignal_sourceability_toggle_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_hiredsignal_sourceability_toggle_tstTest = function() {
    return this.pow_hiredsignal_sourceability_toggle_tstValue_ === 1;
  };



  // POW_INTL_FIELDS_RESUME_LOCALE


  /**
   * Bucket value for pow_intl_fields_resume_locale.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_intl_fields_resume_localeValue_;




  /**
   * Checks if the user is in pow_intl_fields_resume_localeInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_intl_fields_resume_localeInactive = function() {
    return this.pow_intl_fields_resume_localeValue_ === -1;
  };


  /**
   * Checks if the user is in pow_intl_fields_resume_localeControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_intl_fields_resume_localeControl = function() {
    return this.pow_intl_fields_resume_localeValue_ === 0;
  };


  /**
   * Checks if the user is in pow_intl_fields_resume_localeTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_intl_fields_resume_localeTest = function() {
    return this.pow_intl_fields_resume_localeValue_ === 1;
  };



  // POW_LANGUAGES_FIELD_MIGRATION


  /**
   * Bucket value for pow_languages_field_migration.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_languages_field_migrationValue_;




  /**
   * Checks if the user is in pow_languages_field_migrationInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_languages_field_migrationInactive = function() {
    return this.pow_languages_field_migrationValue_ === -1;
  };


  /**
   * Checks if the user is in pow_languages_field_migrationControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_languages_field_migrationControl = function() {
    return this.pow_languages_field_migrationValue_ === 0;
  };


  /**
   * Checks if the user is in pow_languages_field_migrationTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_languages_field_migrationTest = function() {
    return this.pow_languages_field_migrationValue_ === 1;
  };



  // POW_MULTIPLE_RESUME_TST


  /**
   * Bucket value for pow_multiple_resume_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_multiple_resume_tstValue_;




  /**
   * Checks if the user is in pow_multiple_resume_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_multiple_resume_tstInactive = function() {
    return this.pow_multiple_resume_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pow_multiple_resume_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_multiple_resume_tstControl = function() {
    return this.pow_multiple_resume_tstValue_ === 0;
  };


  /**
   * Checks if the user is in pow_multiple_resume_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_multiple_resume_tstTest = function() {
    return this.pow_multiple_resume_tstValue_ === 1;
  };



  // POW_OVERRIDE_NATIVE_APP_CANCEL_BUTTON_TST


  /**
   * Bucket value for pow_override_native_app_cancel_button_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_override_native_app_cancel_button_tstValue_;




  /**
   * Checks if the user is in pow_override_native_app_cancel_button_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_override_native_app_cancel_button_tstInactive = function() {
    return this.pow_override_native_app_cancel_button_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pow_override_native_app_cancel_button_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_override_native_app_cancel_button_tstControl = function() {
    return this.pow_override_native_app_cancel_button_tstValue_ === 0;
  };


  /**
   * Checks if the user is in pow_override_native_app_cancel_button_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_override_native_app_cancel_button_tstTest = function() {
    return this.pow_override_native_app_cancel_button_tstValue_ === 1;
  };



  // POW_PHONE_PAGE_MVR_BUILDER


  /**
   * Bucket value for pow_phone_page_mvr_builder.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_phone_page_mvr_builderValue_;




  /**
   * Checks if the user is in pow_phone_page_mvr_builderInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_phone_page_mvr_builderInactive = function() {
    return this.pow_phone_page_mvr_builderValue_ === -1;
  };


  /**
   * Checks if the user is in pow_phone_page_mvr_builderControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_phone_page_mvr_builderControl = function() {
    return this.pow_phone_page_mvr_builderValue_ === 0;
  };


  /**
   * Checks if the user is in pow_phone_page_mvr_builderTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_phone_page_mvr_builderTest = function() {
    return this.pow_phone_page_mvr_builderValue_ === 1;
  };



  // POW_PRIVACY_PROMO_TST


  /**
   * Bucket value for pow_privacy_promo_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_privacy_promo_tstValue_;




  /**
   * Checks if the user is in pow_privacy_promo_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_privacy_promo_tstInactive = function() {
    return this.pow_privacy_promo_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pow_privacy_promo_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_privacy_promo_tstControl = function() {
    return this.pow_privacy_promo_tstValue_ === 0;
  };


  /**
   * Checks if the user is in pow_privacy_promo_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_privacy_promo_tstActive = function() {
    return this.pow_privacy_promo_tstValue_ === 1;
  };



  // POW_RE_RESUME_LOCALE


  /**
   * Bucket value for pow_re_resume_locale.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_re_resume_localeValue_;




  /**
   * Checks if the user is in pow_re_resume_localeInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_re_resume_localeInactive = function() {
    return this.pow_re_resume_localeValue_ === -1;
  };


  /**
   * Checks if the user is in pow_re_resume_localeControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_re_resume_localeControl = function() {
    return this.pow_re_resume_localeValue_ === 0;
  };


  /**
   * Checks if the user is in pow_re_resume_localeTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_re_resume_localeTest = function() {
    return this.pow_re_resume_localeValue_ === 1;
  };



  // POW_REDESIGN_LOCALE_PICKER


  /**
   * Bucket value for pow_redesign_locale_picker.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_redesign_locale_pickerValue_;




  /**
   * Checks if the user is in pow_redesign_locale_pickerInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_redesign_locale_pickerInactive = function() {
    return this.pow_redesign_locale_pickerValue_ === -1;
  };


  /**
   * Checks if the user is in pow_redesign_locale_pickerControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_redesign_locale_pickerControl = function() {
    return this.pow_redesign_locale_pickerValue_ === 0;
  };


  /**
   * Checks if the user is in pow_redesign_locale_pickerTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_redesign_locale_pickerTest = function() {
    return this.pow_redesign_locale_pickerValue_ === 1;
  };



  // POW_REUSABLE_PAY_COMPONENT_TST


  /**
   * Bucket value for pow_reusable_pay_component_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_reusable_pay_component_tstValue_;




  /**
   * Checks if the user is in pow_reusable_pay_component_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_reusable_pay_component_tstInactive = function() {
    return this.pow_reusable_pay_component_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pow_reusable_pay_component_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_reusable_pay_component_tstControl = function() {
    return this.pow_reusable_pay_component_tstValue_ === 0;
  };


  /**
   * Checks if the user is in pow_reusable_pay_component_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_reusable_pay_component_tstTest = function() {
    return this.pow_reusable_pay_component_tstValue_ === 1;
  };



  // POW_SKILLS_TEST_DEPRECATION


  /**
   * Bucket value for pow_skills_test_deprecation.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_skills_test_deprecationValue_;




  /**
   * Checks if the user is in pow_skills_test_deprecationInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_skills_test_deprecationInactive = function() {
    return this.pow_skills_test_deprecationValue_ === -1;
  };


  /**
   * Checks if the user is in pow_skills_test_deprecationControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_skills_test_deprecationControl = function() {
    return this.pow_skills_test_deprecationValue_ === 0;
  };


  /**
   * Checks if the user is in pow_skills_test_deprecationBanner.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_skills_test_deprecationBanner = function() {
    return this.pow_skills_test_deprecationValue_ === 1;
  };


  /**
   * Checks if the user is in pow_skills_test_deprecationTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_skills_test_deprecationTest = function() {
    return this.pow_skills_test_deprecationValue_ === 2;
  };



  // POW_SKILLS_VALIDATION


  /**
   * Bucket value for pow_skills_validation.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_skills_validationValue_;




  /**
   * Checks if the user is in pow_skills_validationInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_skills_validationInactive = function() {
    return this.pow_skills_validationValue_ === -1;
  };


  /**
   * Checks if the user is in pow_skills_validationControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_skills_validationControl = function() {
    return this.pow_skills_validationValue_ === 0;
  };


  /**
   * Checks if the user is in pow_skills_validationTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_skills_validationTest = function() {
    return this.pow_skills_validationValue_ === 1;
  };



  // PROF_AUTO_RESUME_SECTIONS_SCHEMA_TST


  /**
   * Bucket value for prof_auto_resume_sections_schema_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_auto_resume_sections_schema_tstValue_;




  /**
   * Checks if the user is in prof_auto_resume_sections_schema_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_auto_resume_sections_schema_tstInactive = function() {
    return this.prof_auto_resume_sections_schema_tstValue_ === -1;
  };


  /**
   * Checks if the user is in prof_auto_resume_sections_schema_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_auto_resume_sections_schema_tstControl = function() {
    return this.prof_auto_resume_sections_schema_tstValue_ === 0;
  };


  /**
   * Checks if the user is in prof_auto_resume_sections_schema_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_auto_resume_sections_schema_tstActive = function() {
    return this.prof_auto_resume_sections_schema_tstValue_ === 1;
  };



  // PROF_COMPLETION_WIDGET


  /**
   * Bucket value for prof_completion_widget.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_completion_widgetValue_;




  /**
   * Checks if the user is in prof_completion_widgetInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_completion_widgetInactive = function() {
    return this.prof_completion_widgetValue_ === -1;
  };


  /**
   * Checks if the user is in prof_completion_widgetControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_completion_widgetControl = function() {
    return this.prof_completion_widgetValue_ === 0;
  };


  /**
   * Checks if the user is in prof_completion_widgetTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_completion_widgetTest = function() {
    return this.prof_completion_widgetValue_ === 1;
  };



  // PROF_DATA_MERGE_PARSED_RESUME_TST


  /**
   * Bucket value for prof_data_merge_parsed_resume_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_data_merge_parsed_resume_tstValue_;




  /**
   * Checks if the user is in prof_data_merge_parsed_resume_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_data_merge_parsed_resume_tstInactive = function() {
    return this.prof_data_merge_parsed_resume_tstValue_ === -1;
  };


  /**
   * Checks if the user is in prof_data_merge_parsed_resume_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_data_merge_parsed_resume_tstControl = function() {
    return this.prof_data_merge_parsed_resume_tstValue_ === 0;
  };


  /**
   * Checks if the user is in prof_data_merge_parsed_resume_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_data_merge_parsed_resume_tstTest = function() {
    return this.prof_data_merge_parsed_resume_tstValue_ === 1;
  };


  /**
   * Checks if the user is in prof_data_merge_parsed_resume_tstGrp2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_data_merge_parsed_resume_tstGrp2 = function() {
    return this.prof_data_merge_parsed_resume_tstValue_ === 2;
  };



  // PROF_EMPLOYER_BLOCKING_SOURCING_OPT_IN


  /**
   * Bucket value for prof_employer_blocking_sourcing_opt_in.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_employer_blocking_sourcing_opt_inValue_;




  /**
   * Checks if the user is in prof_employer_blocking_sourcing_opt_inInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_employer_blocking_sourcing_opt_inInactive = function() {
    return this.prof_employer_blocking_sourcing_opt_inValue_ === -1;
  };


  /**
   * Checks if the user is in prof_employer_blocking_sourcing_opt_inControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_employer_blocking_sourcing_opt_inControl = function() {
    return this.prof_employer_blocking_sourcing_opt_inValue_ === 0;
  };


  /**
   * Checks if the user is in prof_employer_blocking_sourcing_opt_inTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_employer_blocking_sourcing_opt_inTest = function() {
    return this.prof_employer_blocking_sourcing_opt_inValue_ === 1;
  };



  // PROF_FE_MERGE_SECOND_PHASE


  /**
   * Bucket value for prof_fe_merge_second_phase.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_fe_merge_second_phaseValue_;




  /**
   * Checks if the user is in prof_fe_merge_second_phaseInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_fe_merge_second_phaseInactive = function() {
    return this.prof_fe_merge_second_phaseValue_ === -1;
  };


  /**
   * Checks if the user is in prof_fe_merge_second_phaseControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_fe_merge_second_phaseControl = function() {
    return this.prof_fe_merge_second_phaseValue_ === 0;
  };


  /**
   * Checks if the user is in prof_fe_merge_second_phaseGrp1.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_fe_merge_second_phaseGrp1 = function() {
    return this.prof_fe_merge_second_phaseValue_ === 1;
  };


  /**
   * Checks if the user is in prof_fe_merge_second_phaseGrp2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_fe_merge_second_phaseGrp2 = function() {
    return this.prof_fe_merge_second_phaseValue_ === 2;
  };


  /**
   * Checks if the user is in prof_fe_merge_second_phaseGrp3.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_fe_merge_second_phaseGrp3 = function() {
    return this.prof_fe_merge_second_phaseValue_ === 3;
  };



  // PROF_JP_NO_THUMBNAIL


  /**
   * Bucket value for prof_jp_no_thumbnail.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_jp_no_thumbnailValue_;




  /**
   * Checks if the user is in prof_jp_no_thumbnailInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_jp_no_thumbnailInactive = function() {
    return this.prof_jp_no_thumbnailValue_ === -1;
  };


  /**
   * Checks if the user is in prof_jp_no_thumbnailControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_jp_no_thumbnailControl = function() {
    return this.prof_jp_no_thumbnailValue_ === 0;
  };


  /**
   * Checks if the user is in prof_jp_no_thumbnailTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_jp_no_thumbnailTest = function() {
    return this.prof_jp_no_thumbnailValue_ === 1;
  };



  // PROF_MVP_DATA_MERGE_CROWTAXO_TOG


  /**
   * Bucket value for prof_mvp_data_merge_crowtaxo_tog.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_mvp_data_merge_crowtaxo_togValue_;


  /**
   * Payload value for prof_mvp_data_merge_crowtaxo_tog.
   * @type {Object}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_mvp_data_merge_crowtaxo_togPayloadValue_;


  /**
   * Get the payload value for prof_mvp_data_merge_crowtaxo_tog.
   * @return {Object}
   */
  ProfileProctorGroups_.prototype.getProf_mvp_data_merge_crowtaxo_togPayloadValue = function() {
    return this.prof_mvp_data_merge_crowtaxo_togPayloadValue_;
  };


  /**
   * Checks if the user is in prof_mvp_data_merge_crowtaxo_togInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_mvp_data_merge_crowtaxo_togInactive = function() {
    return this.prof_mvp_data_merge_crowtaxo_togValue_ === -1;
  };


  /**
   * Checks if the user is in prof_mvp_data_merge_crowtaxo_togControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_mvp_data_merge_crowtaxo_togControl = function() {
    return this.prof_mvp_data_merge_crowtaxo_togValue_ === 0;
  };


  /**
   * Checks if the user is in prof_mvp_data_merge_crowtaxo_togGrp1.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_mvp_data_merge_crowtaxo_togGrp1 = function() {
    return this.prof_mvp_data_merge_crowtaxo_togValue_ === 1;
  };


  /**
   * Checks if the user is in prof_mvp_data_merge_crowtaxo_togGrp2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_mvp_data_merge_crowtaxo_togGrp2 = function() {
    return this.prof_mvp_data_merge_crowtaxo_togValue_ === 2;
  };


  /**
   * Checks if the user is in prof_mvp_data_merge_crowtaxo_togGrp3.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_mvp_data_merge_crowtaxo_togGrp3 = function() {
    return this.prof_mvp_data_merge_crowtaxo_togValue_ === 3;
  };


  /**
   * Checks if the user is in prof_mvp_data_merge_crowtaxo_togGrp4.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_mvp_data_merge_crowtaxo_togGrp4 = function() {
    return this.prof_mvp_data_merge_crowtaxo_togValue_ === 4;
  };


  /**
   * Checks if the user is in prof_mvp_data_merge_crowtaxo_togGrp5.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_mvp_data_merge_crowtaxo_togGrp5 = function() {
    return this.prof_mvp_data_merge_crowtaxo_togValue_ === 5;
  };


  /**
   * Checks if the user is in prof_mvp_data_merge_crowtaxo_togGrp6.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_mvp_data_merge_crowtaxo_togGrp6 = function() {
    return this.prof_mvp_data_merge_crowtaxo_togValue_ === 6;
  };



  // PROF_PDF_CONFIRMATION


  /**
   * Bucket value for prof_pdf_confirmation.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_pdf_confirmationValue_;




  /**
   * Checks if the user is in prof_pdf_confirmationInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_pdf_confirmationInactive = function() {
    return this.prof_pdf_confirmationValue_ === -1;
  };


  /**
   * Checks if the user is in prof_pdf_confirmationControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_pdf_confirmationControl = function() {
    return this.prof_pdf_confirmationValue_ === 0;
  };


  /**
   * Checks if the user is in prof_pdf_confirmationActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_pdf_confirmationActive = function() {
    return this.prof_pdf_confirmationValue_ === 1;
  };



  // PROF_PREFERENCE_IMPROVEMENT_TOGGLE


  /**
   * Bucket value for prof_preference_improvement_toggle.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_preference_improvement_toggleValue_;




  /**
   * Checks if the user is in prof_preference_improvement_toggleInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_preference_improvement_toggleInactive = function() {
    return this.prof_preference_improvement_toggleValue_ === -1;
  };


  /**
   * Checks if the user is in prof_preference_improvement_toggleControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_preference_improvement_toggleControl = function() {
    return this.prof_preference_improvement_toggleValue_ === 0;
  };


  /**
   * Checks if the user is in prof_preference_improvement_toggleGrp1.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_preference_improvement_toggleGrp1 = function() {
    return this.prof_preference_improvement_toggleValue_ === 1;
  };


  /**
   * Checks if the user is in prof_preference_improvement_toggleGrp2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_preference_improvement_toggleGrp2 = function() {
    return this.prof_preference_improvement_toggleValue_ === 2;
  };



  // PROF_RDI_AUTO_MERGE_ALERT_TOG


  /**
   * Bucket value for prof_rdi_auto_merge_alert_tog.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_rdi_auto_merge_alert_togValue_;




  /**
   * Checks if the user is in prof_rdi_auto_merge_alert_togInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_rdi_auto_merge_alert_togInactive = function() {
    return this.prof_rdi_auto_merge_alert_togValue_ === -1;
  };


  /**
   * Checks if the user is in prof_rdi_auto_merge_alert_togControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_rdi_auto_merge_alert_togControl = function() {
    return this.prof_rdi_auto_merge_alert_togValue_ === 0;
  };


  /**
   * Checks if the user is in prof_rdi_auto_merge_alert_togTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_rdi_auto_merge_alert_togTest = function() {
    return this.prof_rdi_auto_merge_alert_togValue_ === 1;
  };



  // PROF_RDI_SINGLE_PAGE_TOG


  /**
   * Bucket value for prof_rdi_single_page_tog.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_rdi_single_page_togValue_;




  /**
   * Checks if the user is in prof_rdi_single_page_togInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_rdi_single_page_togInactive = function() {
    return this.prof_rdi_single_page_togValue_ === -1;
  };


  /**
   * Checks if the user is in prof_rdi_single_page_togControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_rdi_single_page_togControl = function() {
    return this.prof_rdi_single_page_togValue_ === 0;
  };


  /**
   * Checks if the user is in prof_rdi_single_page_togTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_rdi_single_page_togTest = function() {
    return this.prof_rdi_single_page_togValue_ === 1;
  };



  // PROF_REMOVE_CONVERT_TO_INDEED_RESUME_OPTION


  /**
   * Bucket value for prof_remove_convert_to_indeed_resume_option.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_remove_convert_to_indeed_resume_optionValue_;




  /**
   * Checks if the user is in prof_remove_convert_to_indeed_resume_optionInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_remove_convert_to_indeed_resume_optionInactive = function() {
    return this.prof_remove_convert_to_indeed_resume_optionValue_ === -1;
  };


  /**
   * Checks if the user is in prof_remove_convert_to_indeed_resume_optionControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_remove_convert_to_indeed_resume_optionControl = function() {
    return this.prof_remove_convert_to_indeed_resume_optionValue_ === 0;
  };


  /**
   * Checks if the user is in prof_remove_convert_to_indeed_resume_optionTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_remove_convert_to_indeed_resume_optionTest = function() {
    return this.prof_remove_convert_to_indeed_resume_optionValue_ === 1;
  };



  // PROF_RN_TWO_TAB


  /**
   * Bucket value for prof_rn_two_tab.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_rn_two_tabValue_;




  /**
   * Checks if the user is in prof_rn_two_tabInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_rn_two_tabInactive = function() {
    return this.prof_rn_two_tabValue_ === -1;
  };


  /**
   * Checks if the user is in prof_rn_two_tabControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_rn_two_tabControl = function() {
    return this.prof_rn_two_tabValue_ === 0;
  };


  /**
   * Checks if the user is in prof_rn_two_tabControl_aa.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_rn_two_tabControl_aa = function() {
    return this.prof_rn_two_tabValue_ === 1;
  };


  /**
   * Checks if the user is in prof_rn_two_tabActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_rn_two_tabActive = function() {
    return this.prof_rn_two_tabValue_ === 2;
  };



  // PROF_SG_WORK_AUTH_FOR_PARSED_REZ_TST


  /**
   * Bucket value for prof_sg_work_auth_for_parsed_rez_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_sg_work_auth_for_parsed_rez_tstValue_;




  /**
   * Checks if the user is in prof_sg_work_auth_for_parsed_rez_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_sg_work_auth_for_parsed_rez_tstInactive = function() {
    return this.prof_sg_work_auth_for_parsed_rez_tstValue_ === -1;
  };


  /**
   * Checks if the user is in prof_sg_work_auth_for_parsed_rez_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_sg_work_auth_for_parsed_rez_tstControl = function() {
    return this.prof_sg_work_auth_for_parsed_rez_tstValue_ === 0;
  };


  /**
   * Checks if the user is in prof_sg_work_auth_for_parsed_rez_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_sg_work_auth_for_parsed_rez_tstTest = function() {
    return this.prof_sg_work_auth_for_parsed_rez_tstValue_ === 1;
  };



  // PROF_TABBED_EXP


  /**
   * Bucket value for prof_tabbed_exp.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_tabbed_expValue_;




  /**
   * Checks if the user is in prof_tabbed_expInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_expInactive = function() {
    return this.prof_tabbed_expValue_ === -1;
  };


  /**
   * Checks if the user is in prof_tabbed_expControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_expControl = function() {
    return this.prof_tabbed_expValue_ === 0;
  };


  /**
   * Checks if the user is in prof_tabbed_expTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_expTest = function() {
    return this.prof_tabbed_expValue_ === 1;
  };


  /**
   * Checks if the user is in prof_tabbed_expGrp2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_expGrp2 = function() {
    return this.prof_tabbed_expValue_ === 2;
  };


  /**
   * Checks if the user is in prof_tabbed_expGrp3.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_expGrp3 = function() {
    return this.prof_tabbed_expValue_ === 3;
  };



  // PROF_TABBED_EXP_RESUME_DATA_IMPORT


  /**
   * Bucket value for prof_tabbed_exp_resume_data_import.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_tabbed_exp_resume_data_importValue_;




  /**
   * Checks if the user is in prof_tabbed_exp_resume_data_importInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_exp_resume_data_importInactive = function() {
    return this.prof_tabbed_exp_resume_data_importValue_ === -1;
  };


  /**
   * Checks if the user is in prof_tabbed_exp_resume_data_importControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_exp_resume_data_importControl = function() {
    return this.prof_tabbed_exp_resume_data_importValue_ === 0;
  };


  /**
   * Checks if the user is in prof_tabbed_exp_resume_data_importTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_exp_resume_data_importTest = function() {
    return this.prof_tabbed_exp_resume_data_importValue_ === 1;
  };



  // PROF_TABBED_EXP_SMILEY_SURVEY


  /**
   * Bucket value for prof_tabbed_exp_smiley_survey.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_tabbed_exp_smiley_surveyValue_;




  /**
   * Checks if the user is in prof_tabbed_exp_smiley_surveyInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_exp_smiley_surveyInactive = function() {
    return this.prof_tabbed_exp_smiley_surveyValue_ === -1;
  };


  /**
   * Checks if the user is in prof_tabbed_exp_smiley_surveyControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_exp_smiley_surveyControl = function() {
    return this.prof_tabbed_exp_smiley_surveyValue_ === 0;
  };


  /**
   * Checks if the user is in prof_tabbed_exp_smiley_surveyTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_exp_smiley_surveyTest = function() {
    return this.prof_tabbed_exp_smiley_surveyValue_ === 1;
  };



  // PROF_UPLOAD_FILE_REDACTION_TST


  /**
   * Bucket value for prof_upload_file_redaction_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_upload_file_redaction_tstValue_;




  /**
   * Checks if the user is in prof_upload_file_redaction_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_upload_file_redaction_tstInactive = function() {
    return this.prof_upload_file_redaction_tstValue_ === -1;
  };


  /**
   * Checks if the user is in prof_upload_file_redaction_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_upload_file_redaction_tstControl = function() {
    return this.prof_upload_file_redaction_tstValue_ === 0;
  };


  /**
   * Checks if the user is in prof_upload_file_redaction_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_upload_file_redaction_tstActive = function() {
    return this.prof_upload_file_redaction_tstValue_ === 1;
  };



  // PROFAUTO_DOC_TO_PDF_CONVERSION_TST


  /**
   * Bucket value for profauto_doc_to_pdf_conversion_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profauto_doc_to_pdf_conversion_tstValue_;




  /**
   * Checks if the user is in profauto_doc_to_pdf_conversion_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfauto_doc_to_pdf_conversion_tstInactive = function() {
    return this.profauto_doc_to_pdf_conversion_tstValue_ === -1;
  };


  /**
   * Checks if the user is in profauto_doc_to_pdf_conversion_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfauto_doc_to_pdf_conversion_tstControl = function() {
    return this.profauto_doc_to_pdf_conversion_tstValue_ === 0;
  };


  /**
   * Checks if the user is in profauto_doc_to_pdf_conversion_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfauto_doc_to_pdf_conversion_tstActive = function() {
    return this.profauto_doc_to_pdf_conversion_tstValue_ === 1;
  };



  // PROFAUTO_POW_COMMUTE_TIME_TST


  /**
   * Bucket value for profauto_pow_commute_time_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profauto_pow_commute_time_tstValue_;




  /**
   * Checks if the user is in profauto_pow_commute_time_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfauto_pow_commute_time_tstInactive = function() {
    return this.profauto_pow_commute_time_tstValue_ === -1;
  };


  /**
   * Checks if the user is in profauto_pow_commute_time_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfauto_pow_commute_time_tstControl = function() {
    return this.profauto_pow_commute_time_tstValue_ === 0;
  };


  /**
   * Checks if the user is in profauto_pow_commute_time_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfauto_pow_commute_time_tstActive = function() {
    return this.profauto_pow_commute_time_tstValue_ === 1;
  };



  // PROFILE_AI_SUMMARY_TST


  /**
   * Bucket value for profile_ai_summary_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_ai_summary_tstValue_;




  /**
   * Checks if the user is in profile_ai_summary_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_ai_summary_tstInactive = function() {
    return this.profile_ai_summary_tstValue_ === -1;
  };


  /**
   * Checks if the user is in profile_ai_summary_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_ai_summary_tstControl = function() {
    return this.profile_ai_summary_tstValue_ === 0;
  };


  /**
   * Checks if the user is in profile_ai_summary_tstPenguin.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_ai_summary_tstPenguin = function() {
    return this.profile_ai_summary_tstValue_ === 1;
  };


  /**
   * Checks if the user is in profile_ai_summary_tstGpt4omini.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_ai_summary_tstGpt4omini = function() {
    return this.profile_ai_summary_tstValue_ === 2;
  };


  /**
   * Checks if the user is in profile_ai_summary_tstGpt4o.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_ai_summary_tstGpt4o = function() {
    return this.profile_ai_summary_tstValue_ === 3;
  };



  // PROFILE_AI_WORK_DESCRIPTION_TST


  /**
   * Bucket value for profile_ai_work_description_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_ai_work_description_tstValue_;




  /**
   * Checks if the user is in profile_ai_work_description_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_ai_work_description_tstInactive = function() {
    return this.profile_ai_work_description_tstValue_ === -1;
  };


  /**
   * Checks if the user is in profile_ai_work_description_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_ai_work_description_tstControl = function() {
    return this.profile_ai_work_description_tstValue_ === 0;
  };


  /**
   * Checks if the user is in profile_ai_work_description_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_ai_work_description_tstTest = function() {
    return this.profile_ai_work_description_tstValue_ === 1;
  };



  // PROFILE_EXTRACTED_QUALIFICATIONS_TST


  /**
   * Bucket value for profile_extracted_qualifications_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_extracted_qualifications_tstValue_;




  /**
   * Checks if the user is in profile_extracted_qualifications_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_extracted_qualifications_tstInactive = function() {
    return this.profile_extracted_qualifications_tstValue_ === -1;
  };


  /**
   * Checks if the user is in profile_extracted_qualifications_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_extracted_qualifications_tstControl = function() {
    return this.profile_extracted_qualifications_tstValue_ === 0;
  };


  /**
   * Checks if the user is in profile_extracted_qualifications_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_extracted_qualifications_tstActive = function() {
    return this.profile_extracted_qualifications_tstValue_ === 1;
  };



  // PROFILE_ONE_CSP_MODE_TOG


  /**
   * Bucket value for profile_one_csp_mode_tog.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_one_csp_mode_togValue_;




  /**
   * Checks if the user is in profile_one_csp_mode_togInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_csp_mode_togInactive = function() {
    return this.profile_one_csp_mode_togValue_ === -1;
  };


  /**
   * Checks if the user is in profile_one_csp_mode_togControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_csp_mode_togControl = function() {
    return this.profile_one_csp_mode_togValue_ === 0;
  };


  /**
   * Checks if the user is in profile_one_csp_mode_togActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_csp_mode_togActive = function() {
    return this.profile_one_csp_mode_togValue_ === 1;
  };



  // PROFILE_ONE_DATADOG_RUM_TOGGLE


  /**
   * Bucket value for profile_one_datadog_rum_toggle.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_one_datadog_rum_toggleValue_;




  /**
   * Checks if the user is in profile_one_datadog_rum_toggleInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_datadog_rum_toggleInactive = function() {
    return this.profile_one_datadog_rum_toggleValue_ === -1;
  };


  /**
   * Checks if the user is in profile_one_datadog_rum_toggleControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_datadog_rum_toggleControl = function() {
    return this.profile_one_datadog_rum_toggleValue_ === 0;
  };


  /**
   * Checks if the user is in profile_one_datadog_rum_toggleActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_datadog_rum_toggleActive = function() {
    return this.profile_one_datadog_rum_toggleValue_ === 1;
  };



  // PROFILE_ONE_FULLSTORY_TST


  /**
   * Bucket value for profile_one_fullstory_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_one_fullstory_tstValue_;




  /**
   * Checks if the user is in profile_one_fullstory_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_fullstory_tstInactive = function() {
    return this.profile_one_fullstory_tstValue_ === -1;
  };


  /**
   * Checks if the user is in profile_one_fullstory_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_fullstory_tstControl = function() {
    return this.profile_one_fullstory_tstValue_ === 0;
  };


  /**
   * Checks if the user is in profile_one_fullstory_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_fullstory_tstActive = function() {
    return this.profile_one_fullstory_tstValue_ === 1;
  };



  // PROFILE_ONE_REDESIGN_PREFERENCES_TST


  /**
   * Bucket value for profile_one_redesign_preferences_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_one_redesign_preferences_tstValue_;




  /**
   * Checks if the user is in profile_one_redesign_preferences_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_redesign_preferences_tstInactive = function() {
    return this.profile_one_redesign_preferences_tstValue_ === -1;
  };


  /**
   * Checks if the user is in profile_one_redesign_preferences_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_redesign_preferences_tstControl = function() {
    return this.profile_one_redesign_preferences_tstValue_ === 0;
  };


  /**
   * Checks if the user is in profile_one_redesign_preferences_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_redesign_preferences_tstActive = function() {
    return this.profile_one_redesign_preferences_tstValue_ === 1;
  };



  // PROFILE_PHONE_SIMPLIFICATION


  /**
   * Bucket value for profile_phone_simplification.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_phone_simplificationValue_;




  /**
   * Checks if the user is in profile_phone_simplificationInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_phone_simplificationInactive = function() {
    return this.profile_phone_simplificationValue_ === -1;
  };


  /**
   * Checks if the user is in profile_phone_simplificationControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_phone_simplificationControl = function() {
    return this.profile_phone_simplificationValue_ === 0;
  };


  /**
   * Checks if the user is in profile_phone_simplificationTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_phone_simplificationTest = function() {
    return this.profile_phone_simplificationValue_ === 1;
  };



  // PROFILE_PHOTOS_TOG


  /**
   * Bucket value for profile_photos_tog.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_photos_togValue_;




  /**
   * Checks if the user is in profile_photos_togInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_photos_togInactive = function() {
    return this.profile_photos_togValue_ === -1;
  };


  /**
   * Checks if the user is in profile_photos_togControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_photos_togControl = function() {
    return this.profile_photos_togValue_ === 0;
  };


  /**
   * Checks if the user is in profile_photos_togActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_photos_togActive = function() {
    return this.profile_photos_togValue_ === 1;
  };



  // PROFILE_SCORE_TST


  /**
   * Bucket value for profile_score_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_score_tstValue_;




  /**
   * Checks if the user is in profile_score_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_score_tstInactive = function() {
    return this.profile_score_tstValue_ === -1;
  };


  /**
   * Checks if the user is in profile_score_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_score_tstControl = function() {
    return this.profile_score_tstValue_ === 0;
  };


  /**
   * Checks if the user is in profile_score_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_score_tstTest = function() {
    return this.profile_score_tstValue_ === 1;
  };



  // PROFILE_TEXT_EXPERIENCE_INPUT_TST


  /**
   * Bucket value for profile_text_experience_input_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_text_experience_input_tstValue_;




  /**
   * Checks if the user is in profile_text_experience_input_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_text_experience_input_tstInactive = function() {
    return this.profile_text_experience_input_tstValue_ === -1;
  };


  /**
   * Checks if the user is in profile_text_experience_input_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_text_experience_input_tstControl = function() {
    return this.profile_text_experience_input_tstValue_ === 0;
  };


  /**
   * Checks if the user is in profile_text_experience_input_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_text_experience_input_tstActive = function() {
    return this.profile_text_experience_input_tstValue_ === 1;
  };



  // PROFILE_TITLE_MATCH_AUTOCOMPLETE_DATASET_TST


  /**
   * Bucket value for profile_title_match_autocomplete_dataset_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_title_match_autocomplete_dataset_tstValue_;


  /**
   * Payload value for profile_title_match_autocomplete_dataset_tst.
   * @type {Object}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_title_match_autocomplete_dataset_tstPayloadValue_;


  /**
   * Get the payload value for profile_title_match_autocomplete_dataset_tst.
   * @return {Object}
   */
  ProfileProctorGroups_.prototype.getProfile_title_match_autocomplete_dataset_tstPayloadValue = function() {
    return this.profile_title_match_autocomplete_dataset_tstPayloadValue_;
  };


  /**
   * Checks if the user is in profile_title_match_autocomplete_dataset_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_title_match_autocomplete_dataset_tstInactive = function() {
    return this.profile_title_match_autocomplete_dataset_tstValue_ === -1;
  };


  /**
   * Checks if the user is in profile_title_match_autocomplete_dataset_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_title_match_autocomplete_dataset_tstControl = function() {
    return this.profile_title_match_autocomplete_dataset_tstValue_ === 0;
  };


  /**
   * Checks if the user is in profile_title_match_autocomplete_dataset_tstEnableJobTypeAutoComplete.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_title_match_autocomplete_dataset_tstEnableJobTypeAutoComplete = function() {
    return this.profile_title_match_autocomplete_dataset_tstValue_ === 1;
  };


  /**
   * Checks if the user is in profile_title_match_autocomplete_dataset_tstEnableJobTypeAutoCompleteCanonOnly.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_title_match_autocomplete_dataset_tstEnableJobTypeAutoCompleteCanonOnly = function() {
    return this.profile_title_match_autocomplete_dataset_tstValue_ === 2;
  };


  /**
   * Checks if the user is in profile_title_match_autocomplete_dataset_tstEnableJobTypeAutoCompleteCanonAltLabels.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_title_match_autocomplete_dataset_tstEnableJobTypeAutoCompleteCanonAltLabels = function() {
    return this.profile_title_match_autocomplete_dataset_tstValue_ === 3;
  };



  // PROFILE_UPDATE_APP_BANNER_TOG


  /**
   * Bucket value for profile_update_app_banner_tog.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_update_app_banner_togValue_;




  /**
   * Checks if the user is in profile_update_app_banner_togInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_update_app_banner_togInactive = function() {
    return this.profile_update_app_banner_togValue_ === -1;
  };


  /**
   * Checks if the user is in profile_update_app_banner_togControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_update_app_banner_togControl = function() {
    return this.profile_update_app_banner_togValue_ === 0;
  };


  /**
   * Checks if the user is in profile_update_app_banner_togTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_update_app_banner_togTest = function() {
    return this.profile_update_app_banner_togValue_ === 1;
  };



  // PROFILE_YOE_REMOVAL_TOG


  /**
   * Bucket value for profile_yoe_removal_tog.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_yoe_removal_togValue_;




  /**
   * Checks if the user is in profile_yoe_removal_togInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_yoe_removal_togInactive = function() {
    return this.profile_yoe_removal_togValue_ === -1;
  };


  /**
   * Checks if the user is in profile_yoe_removal_togControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_yoe_removal_togControl = function() {
    return this.profile_yoe_removal_togValue_ === 0;
  };


  /**
   * Checks if the user is in profile_yoe_removal_togTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_yoe_removal_togTest = function() {
    return this.profile_yoe_removal_togValue_ === 1;
  };



  // RDP_MODERNIZATION


  /**
   * Bucket value for rdp_modernization.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.rdp_modernizationValue_;




  /**
   * Checks if the user is in rdp_modernizationInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRdp_modernizationInactive = function() {
    return this.rdp_modernizationValue_ === -1;
  };


  /**
   * Checks if the user is in rdp_modernizationControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRdp_modernizationControl = function() {
    return this.rdp_modernizationValue_ === 0;
  };


  /**
   * Checks if the user is in rdp_modernizationTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRdp_modernizationTest = function() {
    return this.rdp_modernizationValue_ === 1;
  };



  // RDP_MODERNIZATION_POW


  /**
   * Bucket value for rdp_modernization_pow.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.rdp_modernization_powValue_;




  /**
   * Checks if the user is in rdp_modernization_powInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRdp_modernization_powInactive = function() {
    return this.rdp_modernization_powValue_ === -1;
  };


  /**
   * Checks if the user is in rdp_modernization_powControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRdp_modernization_powControl = function() {
    return this.rdp_modernization_powValue_ === 0;
  };


  /**
   * Checks if the user is in rdp_modernization_powTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRdp_modernization_powTest = function() {
    return this.rdp_modernization_powValue_ === 1;
  };



  // RDP_PDF_RESUME_FACELIFT


  /**
   * Bucket value for rdp_pdf_resume_facelift.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.rdp_pdf_resume_faceliftValue_;




  /**
   * Checks if the user is in rdp_pdf_resume_faceliftInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRdp_pdf_resume_faceliftInactive = function() {
    return this.rdp_pdf_resume_faceliftValue_ === -1;
  };


  /**
   * Checks if the user is in rdp_pdf_resume_faceliftControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRdp_pdf_resume_faceliftControl = function() {
    return this.rdp_pdf_resume_faceliftValue_ === 0;
  };


  /**
   * Checks if the user is in rdp_pdf_resume_faceliftTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRdp_pdf_resume_faceliftTest = function() {
    return this.rdp_pdf_resume_faceliftValue_ === 1;
  };



  // RE_UPLOAD_TO_REPLACE


  /**
   * Bucket value for re_upload_to_replace.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.re_upload_to_replaceValue_;




  /**
   * Checks if the user is in re_upload_to_replaceInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRe_upload_to_replaceInactive = function() {
    return this.re_upload_to_replaceValue_ === -1;
  };


  /**
   * Checks if the user is in re_upload_to_replaceControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRe_upload_to_replaceControl = function() {
    return this.re_upload_to_replaceValue_ === 0;
  };


  /**
   * Checks if the user is in re_upload_to_replaceTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRe_upload_to_replaceTest = function() {
    return this.re_upload_to_replaceValue_ === 1;
  };



  // SI_PROFILE_EDUCATION_DESCRIPTION_INITIALLY_HIDDEN_TST


  /**
   * Bucket value for si_profile_education_description_initially_hidden_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.si_profile_education_description_initially_hidden_tstValue_;




  /**
   * Checks if the user is in si_profile_education_description_initially_hidden_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isSi_profile_education_description_initially_hidden_tstInactive = function() {
    return this.si_profile_education_description_initially_hidden_tstValue_ === -1;
  };


  /**
   * Checks if the user is in si_profile_education_description_initially_hidden_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isSi_profile_education_description_initially_hidden_tstControl = function() {
    return this.si_profile_education_description_initially_hidden_tstValue_ === 0;
  };


  /**
   * Checks if the user is in si_profile_education_description_initially_hidden_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isSi_profile_education_description_initially_hidden_tstTest = function() {
    return this.si_profile_education_description_initially_hidden_tstValue_ === 1;
  };



  /**
  * Static reference to instance of groups class.
  *
  * @type {ProfileProctorGroups_}
  * @private
  */
  var groups_ = null;

  return {

    /**
    * Create an instance of ProfileProctorGroups_.
    * Assign it to a static reference and return it.
    *
    * @param {Array.<Object>} values a list of integers that matches proctor test groups for the request.
    * @return {ProfileProctorGroups_}
    */
    init: function(values) {
      groups_ = new ProfileProctorGroups_(values);
      return groups_;
    },


    /**
    * Get the static reference to our groups instance.
    * If it has not been initialized, return a default instance.
    *
    * @return {ProfileProctorGroups_}
    */
    getGroups: function() {
      if (groups_ == null) {
        groups_ = new ProfileProctorGroups_();
      }
      return groups_;
    }

  };
}));
